const translationsEn = {
    "status": "success",
    "data": {
        "lang": "en_US",
        "app": "hotel",
        "translation": {

        "liveBooking": {
            bookingMovedToOperationsMessage:
                'Your booking has been successfully processed and moved to our operations team for supplier approval.',
            pleaseWaitSupplierApproval:
                'Please wait while the supplier reviews and confirms your reservation. This usually takes a few hours.',
            waitingSupplierApproval: 'WAITING FOR SUPPLIER APPROVAL',
            youWillBeNotified:
                'You will be notified via email once the supplier responds.',
            "processingYourBooking":"Processing your booking...",
            somethingWentWrongOurTeamIsWorkingOnIt:"Something went wrong. Our team is working on it.",
            stepCouldNotBeCompleted:"Step could not be completed.",
            stillProcessingPleaseWait:"Still processing, please wait...",
            stepAlreadyCompleted:"Step already completed.",
            REVALIDATE:"Revalidate",
            RESERVATION:"Reservation",
            SUMMARY:"Summary",
            "PAYMENT_FINALIZATION":"Payment Finalization",
            "bookingProcessStatus": "Booking Process Status",
            "order": "Order",
            "lastUpdate": "Last update",
            "liveStreamingNotAvailable": "Live streaming is not available — using fallback polling. If problems persist, our operations team is reviewing.",
            "noProgressAvailable": "No booking progress available yet.",
            "paymentNotRequired": "Payment not required for this booking (Pay Later option selected)",
            "stepCompletedSuccessfully": "Step completed successfully.",
            "paymentProcessed": "Payment Processed",
            "transactionId": "Transaction ID:",
            "processingOrderLevelJob": "Processing order-level job",
            "emailSentToCustomer": "Email sent to customer",
            "status": "STATUS",
            "retries": "RETRIES",
            "eta": "ETA",
            "timestamp": "TIMESTAMP",
            "processing": "Processing",
            "currentAttempt": "CURRENT ATTEMPT",
            "of": "of",
            "failedToProcess": "Failed to process",
            "supplierApiDidNotRespond": "Supplier API did not respond within the allowed timeframe.",
            "attempts": "ATTEMPTS",
            "duration": "DURATION",
            "failedAt": "FAILED AT",
            "retryAvailable": "Retry available",
            "retryStep": "Retry Step",
            "waitingForRetry": "Waiting for retry after temporary issue.",
            "etaForRetry": "ETA for retry:",
            "awaitingPreviousStep": "Awaiting previous step completion",
            "paymentWillBeProcessed": "Payment will be processed next",
            "emailQueued": "Email notification queued",
            "willBeSentAfterPayment": "Will be sent after payment confirmation",
            "processFailedAtStep": "Process failed at step",
            "processingStep": "Processing step",
            "system": "System",
            "bookingConfirmed": "Booking confirmed!",
            "orderApprovedSuccessfully": "Your order has been approved successfully.",
            "sentItineraryToEmail": "We sent the itinerary to your email.",
            "orderConfirmed": "Order Confirmed",
            "allSystemsGo": "All systems go!",
            "orderNumber": "Order Number",
            "confirmation": "Confirmation",
            "sentToEmail": "Sent to email",
            "checkYourInbox": "Check your inbox",
            "completeItinerarySent": "Your complete itinerary and booking details have been sent to your registered email address.",
            "orderBeingProcessed": "Your order is currently being processed.",
            "waitingForSupplierApproval": "Waiting for supplier approval",
            "orderWaitingForSupplier": "Your order is currently waiting to be approved by the supplier.",
            "errorProcessingStep": "There was an error processing this step.",
            "pending": "pending",
            "awaitingProcessing": "Awaiting processing.",
            "skipped": "skipped",
            "stepNotRequired": "This step was not required for your booking.",
            "completed": "completed",
            "processSteps": "Process Steps",
            "stepsCompletedSuccessfully": "steps completed successfully",
            "allDone": "All Done",
            "failed": "Failed",
            "inProgress": "In Progress",
            "loadingStatus": "Loading status",
            "okay": "Okay",
            "approved": "Approved"
        },

            "crud": {
                "updatedSuccessfully": 'Updated Successfully',
                "validationFailed" : "Validation failed",
                "fieldRequired": "Mandatory field",
                "operationError" : "Error occurred",
                "emptyList" : "No Data Found",
                "failToLoad" : "Error occurred on loading",
                "modelNotFound" : "Not Found",
            },
            "updateCard": {
                "payment_failed_please_update_card": "Payment failed - please update card",
                "open_the_payment_form": "Open the payment form",
            },
            "upgradePlan": {
                "general": {
                    "upgrade_plan": 'Upgrade Plan',
                    "upgrade_plan_to_regular": 'Upgrade To Regular Plan',
                    "upgrade_plan_to_pro": 'Upgrade To PRO Plan',
                  },
                "regular": {
                    "title" : "Upgrade now and get access to Agent 360 products!",
                    "benefits_title_text": "You are currently connected to the Agent 360 Light package, if you upgrade you can get it",
                    "text_1": "Sky 360 Wholesale Products",
                    "text_2": "Hotels for all destinations worldwide",
                    "text_3": "Regular and Low-Cost Flights",
                    "text_4": "Attractions worldwide",
                    "button_text": "Upgrade now to Agent 360!",
                },
                "pro": {
                    "title" : "Upgrade now and get a website for your business with full branding!",
                    "benefits_title_text": "In the SKY 360 Pro package you can enjoy",
                    "text_1": "A website with your unique domain",
                    "text_2": "Business branding - logo and site colors",
                    "text_3": "Promotion of packages and flights on the website by destinations",
                    "text_4": "All bookings made will belong to your agency!",
                    "button_text": "Upgrade now to Pro!"
                },
            },
            "auth": {
                authTypeWarning: 'Please talk with operation to enable Membership - Auth Type not defined',
                logoutSuccess: "You have been logged out successfully",
                pleaseLogin: "Please log in with your credentials",
                authTitle: "Authentication with ID & Mobile",
                verify: "Verify",
                id: "ID",
                idPlaceholder: "Enter your ID",
                idPlaceholderError: "Please enter your ID",
                idDigits: "ID must be 9 digits",
                phone: "Phone",
                phonePlaceholderError: "Please enter your phone number",
                phoneDigits: "Phone must be 9 digits",
                phonePlaceholder: "e.g. 054-1234567",
                send: "Send",
                authModalTitle: "Authentication with ID & Mobile",
                loginLoaeder: "Logging in...",
                loginError: "Login failed. Please try again.",
                otpLoader: "Verifying OTP...",
                loginSuccess: "Logged in successfully",
                otpError: "OTP verification failed. Please try again.",
                otpStartOver: "Didn't get a code? Start over",
                register: "Register",
                firstName: "First Name",
                lastName: "Last Name",
                email: "Email",
                firstNamePlaceholder: 'e.g. John',
                lastNamePlaceholder: "e.g. Doe",
                emailPlaceholder: "e.g. john@example.com",
                firstNamePlaceholderError: "Please enter your first name",
                lastNamePlaceholderError: "Please enter your last name",
                emailPlaceholderError: "Please enter your email",
                emailInvalid: "Please enter a valid email address",
                nameMinLength: "Name must be at least 2 characters",
                registerButton: "Register",
                backToLogin: "Back to Login",
                registrationSuccess: "Registration Successful",
                registrationSuccessMessage: "Your registration was successful",
                registrationError: "Registration failed. Please try again.",
                dontHaveAccount: "Don't have an account?",
                registerHere: "Register here",
                authWithMobile: "Authentication with Mobile",
                registerWithMobile: "Register with Mobile number",
                loginTitle: "Log in to continue",
                loginDescription: "To book or manage an order, please verify your phone number. It takes less than a minute.",
                otpInfo: "We'll send a one-time code (OTP). No password needed.",
                whyLogin: "Why do I need to log in?",
                newHere: "New here?",
                createAccount: "Create an account",
                sendCode: "Send code",
                privacyNotice: "We'll never share your number. SMS rates may apply.",
                mobileNumber: "Mobile number",
                accountNotFound: "Account does not exist",
                continueWithRegistration: "Would you like to continue with registration?",
                continueRegistration: "Continue with registration",
                cancel: "Cancel",
                registrationStepIndicator: "STEP 2 OF 2 — ENTER DETAILS",
                createYourAccount: "Create your account",
                registrationDescription: "Create an account to complete bookings faster and track your orders.",
                mobileHelper: "We'll use this to send your verification code.",
                emailHelper: "Optional — for receiving vouchers and updates.",
                agreeToTerms: "I agree to the",
                terms: "Terms",
                and: "&",
                privacyPolicy: "Privacy Policy",
                alreadyHaveAccount: "Already have an account?",
                logIn: "Log in",
                agreeToTermsError: "Please agree to the Terms & Privacy Policy",
                subscribeNewsletter: "Subscribe to our newsletter",
                newsletterEmailRequired: "Please fill in your email address to subscribe to the newsletter",
                updateProfile: "Update profile",
                logout: "Logout",
                updateProfileSuccess: "Profile updated",
                updateProfileSuccessMessage: "Your profile was updated successfully.",
                updateProfileError: "Failed to update profile. Please try again.",
                close: "Close",
            },
            "contactUs": {
                "requestForQuotation":'Request for quotation',
                "problemWithExistingOrder":"Problem with existing order",
                "customerService":"Customer service",
                "other":"Other",
                "messageReceivedSuccessfully":"Message received successfully",
                "email": "Email",
                "phone": "Phone",
                "fullName": "Full Name",
                "writeUsMessage": "Write us a message",
                "send": "Send",
                "phoneRequired": "Phone number",
                "emailRequired": "Email address",
                "fullNameRequired": "Full name",
                "messageRequired": "Message",
                "nameMinLength": "Name must be at least 2 characters",
                "emailInvalid": "Please enter a valid email address",
                "subjectRequired": "Please select a subject",
                "selectSubject": "Select a subject",
                "messageMin": "Message must be at least 10 characters",
                "aboutUs": "About Us",
                "sending": "Sending...",
                "phoneMinLength": "Phone must be at least 3 characters"
            },
            "cart": {
                "addToCart": "Add to Cart",
                "select": "Select",
                "remove": "Remove",
            },
            "onboarding": {
                 "openOnboarding": "Guide",
                "welcomeTitle": "Welcome to Sky360",
                "subtitle": "Get the most out of our platform with this quick tour. Complete each step to explore everything we offer.",
                "progressTitle": "Your Progress",
                "progressLabel": "Completed",
                "continueOnboarding": "Continue",
                "yourPath": "Your Onboarding Steps",
                "pathSubtitle": "Follow these steps to explore all our products.",
                "markAsDone": "Mark as Done",
                "upNext": "UP NEXT",
                "continue": "Continue",
                "outcomesTitle": "WHAT YOU'LL LEARN",
                "outcome1": "Search & Book Travel",
                "outcome1Desc": "Find packages, flights, hotels and more.",
                "outcome2": "Explore Events & Attractions",
                "outcome2Desc": "Discover local experiences at your destination.",
                "stepCompleted": "Completed",
                "stepCompletedBanner": "Step completed! You're making great progress.",
                "stepCompletionTitle": "Step {num} Completed!",
                "stepCompletionKicker": "Nice work — keep the momentum!",
                "tasksCompleted": "Tasks: {done}/{total} Completed",
                "typeTask": "DO",
                "stepLabel": "STEP",
                "nextStepHint": "Next: Step {num} — {title}",
                "continueUpNext": "Start",
                "tourFinishBtn": "Done",
                "tourNextBtn": "Next",
                "tourPrevBtn": "Back",
                "tourActionHint": "👆 Click the button above to continue",
                "typeLearn": "LEARN",
                "steps": {
                    "step1": {
                        "title": "Search Vacation Packages",
                        "description": "Learn how to find and book all-inclusive vacation packages with flights and hotels included."
                    },
                    "step2": {
                        "title": "Search Flights",
                        "description": "Find one-way or round-trip flights, configure passengers and select your travel dates."
                    },
                    "step3": {
                        "title": "Search Hotels",
                        "description": "Browse hotels worldwide by destination, check-in dates and number of guests."
                    },
                    "step4": {
                        "title": "Explore Attractions",
                        "description": "Discover local activities and tourist attractions at your destination."
                    },
                    "step5": {
                        "title": "Find Events",
                        "description": "Browse upcoming events and optionally bundle them with flights and a hotel."
                    },
                    "step6": {
                        "title": "Search Engine Overview",
                        "description": "The main search area lets you quickly switch between all product types from one place."
                    },
                    "step7": {
                        "title": "Dynamic Package Search",
                        "description": "Learn how to build a custom travel package by selecting a destination or hotel and adding a direct flight."
                    },
                    "step8": {
                        "title": "Create a Flight Reservation",
                        "description": "Walk through the complete flight booking flow — from searching flights all the way to checkout."
                    },
                    "step9": {
                        "title": "Agent Banner Overview",
                        "description": "The agent banner at the top of B2C lets you manage customers, switch pricing modes, view your diamonds balance, and more."
                    },
                    "step10": {
                        "title": "Create a Package Reservation",
                        "description": "Walk through the complete package booking flow — from searching packages all the way to checkout."
                    },
                    "step11": {
                        "title": "Explore the Manage Order Page",
                        "description": "Walk through the manage order page — review booking details, update guest information, and navigate to the payment section."
                    }
                },
                "tour": {
                    "actionStepTitle": "Try It Yourself",
                    "actionStepDesc": "Fill in the details above and click the Search button to complete this step.",
                    "seModHoverTitle": "Explore Module Actions",
                    "seModHoverDesc": "Hover over any module in the page below — a small toolbar appears with actions for that module. Hover over one now to walk through what each action does.",
                    "seModAddTopTitle": "Add Module Above",
                    "seModAddTopDesc": "Inserts a brand-new module directly above this one. Click it to pick a module type and drop it into place.",
                    "seModReorderTitle": "Reorder This Module",
                    "seModReorderDesc": "Use the up and down arrows to move this module earlier or later on the page. The preview reorders instantly.",
                    "seModEditTitle": "Edit This Module",
                    "seModEditDesc": "Opens this module in the settings panel on the left, where you can change its content, layout, and styling.",
                    "seModDeleteTitle": "Remove This Module",
                    "seModDeleteDesc": "Deletes this module from the page. You can always add it back later from the add-module options.",
                    "seModAddBottomTitle": "Add Module Below",
                    "seModAddBottomDesc": "Inserts a brand-new module directly below this one — the same as the top button, just for the slot underneath.",
                    "packagesDpSwitchTitle": "Dynamic Packages — Flight + Hotel",
                    "packagesDpSwitchDesc": "Switch to Dynamic Package mode — choose a hotel and the system pairs it with the lowest available flight for that route, building a competitive full-package price on the spot.",
                    "packagesFeaturesTitle": "Package Categories",
                    "packagesFeaturesDesc": "Choose the type of vacation package you are looking for — organized tours, sport trips, kosher travel and more.",
                    "pkgSpecialTitle": "Special Packages — Fixed 10% Commission",
                    "pkgSpecialDesc": "This is the Special Packages category — curated group travel packages operated by our platform. Every special package comes with a fixed 10% agent commission already built in. Great for quick, confident selling — no price negotiation needed.",
                    "pkgOtherCatsTitle": "Other Package Categories",
                    "pkgOtherCatsDesc": "These are the other package categories — organized tours, kosher travel, ski trips, spa getaways, sports events, and more. Each category automatically filters the available packages and destinations to match that type of travel.",
                    "pkgSelectCatTitle": "Try It — Select a Category",
                    "pkgSelectCatDesc": "Click any category card to filter packages by type. Watch how the destination list updates automatically to show only locations where those packages are available.",
                    "pkgFilteredDestsTitle": "Filtered Destinations",
                    "pkgFilteredDestsDesc": "After selecting a category, the destination list is automatically filtered to show only locations where packages of that type are available. Select a destination to continue.",
                    "pkgDeselectCatTitle": "Click Again to Deselect",
                    "pkgDeselectCatDesc": "Clicking the active category a second time will deselect it — clearing the destination filter and returning to all available packages. Try it now to continue.",
                    "pkgDepartureTitle": "Departure City",
                    "pkgDepartureDesc": "Select the airport or city you will fly from for your vacation package.",
                    "packagesDestTitle": "Choose Destination",
                    "packagesDestDesc": "Select one or more destinations for your vacation package.",
                    "packagesGuestsTitle": "Passengers",
                    "packagesGuestsDesc": "Choose the number of passengers — adults, children, and infants — for your vacation package.",
                    "packagesDatesTitle": "Travel Dates",
                    "packagesDatesDesc": "Pick your departure and return dates for the package.",
                    "packagesSearchTitle": "Search Packages",
                    "packagesSearchDesc": "Click here to find available packages matching your criteria.",
                    "flightTripTypeTitle": "Trip Type",
                    "flightTripTypeDesc": "Toggle this switch to choose between a one-way and a round-trip flight. One-way shows a single date; round-trip shows departure and return dates.",
                    "flightDirectTitle": "Direct Flights Only",
                    "flightDirectDesc": "Enable this switch to filter results to direct flights only — no layovers.",
                    "flightDepartureTitle": "Departure City",
                    "flightDepartureDesc": "Select the airport or city you will be flying from.",
                    "flightArrivalTitle": "Destination",
                    "flightArrivalDesc": "Select the airport or city you want to fly to.",
                    "flightPaxTitle": "Passengers",
                    "flightPaxDesc": "Open the passenger selector to set the number of adults, children and infants.",
                    "flightDatesTitle": "Flight Dates",
                    "flightDatesDesc": "Choose your outbound date (and return date for round-trips). One-way requires only a departure date.",
                    "flightSearchTitle": "Search Flights",
                    "flightSearchDesc": "Click to search for available flights with your selected options.",
                    "hotelDestTitle": "Hotel Destination",
                    "hotelDestDesc": "Search for the city or region where you would like to stay.",
                    "hotelGuestsTitle": "Rooms & Guests",
                    "hotelGuestsDesc": "Add as many rooms as you need and configure each one individually — set the number of adults, children, and infants for every room. Each room's occupancy is set separately, so you can mix configurations to match any group: couples, families, or any combination.",
                    "hotelDatesTitle": "Check-in & Check-out",
                    "hotelDatesDesc": "Pick your hotel check-in and check-out dates.",
                    "hotelSearchTitle": "Search Hotels",
                    "hotelSearchDesc": "Click to browse available hotels for your destination and dates.",
                    "attrDestTitle": "Attraction City",
                    "attrDestDesc": "Type or select the city where you want to find attractions and activities.",
                    "attrDatesTitle": "Activity Dates",
                    "attrDatesDesc": "Choose the date range for the activities you want to explore.",
                    "attrTypeTitle": "Attraction Type",
                    "attrTypeDesc": "Filter attractions by category — museums, outdoor activities, guided tours and more.",
                    "attrSearchTitle": "Find Attractions",
                    "attrSearchDesc": "Click to search for available attractions in your chosen city.",
                    "eventsPackageTitle": "Include Full Package",
                    "eventsPackageDesc": "Enable this toggle to bundle the event with a flight and hotel — a complete travel package in one booking.",
                    "eventsEventTitle": "Search for Event",
                    "eventsEventDesc": "Type an event name or browse available events. With Full Package on, enter a destination city instead.",
                    "eventsDatesTitle": "Event Dates",
                    "eventsDatesDesc": "Select the date range covering the event you want to attend.",
                    "eventsSearchTitle": "Find Events",
                    "eventsSearchDesc": "Click to search for events matching your destination and dates.",
                    "mainTabsTitle": "Choose Search Type",
                    "mainTabsDesc": "Use these tabs to switch between vacation packages, flights, hotels, attractions and events. Each tab shows its own tailored search form.",
                    "mainFormTitle": "Search Form",
                    "mainFormDesc": "Fill in your travel details — destination, dates, passengers — then hit Search to find results.",
                    "mainPkgTabTitle": "Vacation Packages",
                    "mainPkgTabDesc": "Find all-inclusive vacation packages combining flights and hotels. Click this tab to see the packages search form.",
                    "mainPkgFormTitle": "Packages Search Form",
                    "mainPkgFormDesc": "Set your departure city, destination, travel dates, and room configuration for vacation packages. Each field helps find the most suitable options for your clients.",
                    "mainFltTabTitle": "Flights",
                    "mainFltTabDesc": "Search for individual flights — one-way or round-trip. Click this tab to see the flights search form.",
                    "mainFltFormTitle": "Flights Search Form",
                    "mainFltFormDesc": "Choose trip type, departure and arrival cities, travel dates, and passenger count. Toggle \"Direct flights only\" to filter out layovers.",
                    "mainHtlTabTitle": "Hotels",
                    "mainHtlTabDesc": "Search for hotel-only stays worldwide. Click this tab to see the hotels search form.",
                    "mainHtlFormTitle": "Hotels Search Form",
                    "mainHtlFormDesc": "Enter your destination, check-in and check-out dates, and room setup. Add multiple rooms and configure each one separately to match your group.",
                    "mainAttrTabTitle": "Attractions",
                    "mainAttrTabDesc": "Discover local activities, guided tours, and things to do at any destination. Click this tab to see the attractions search form.",
                    "mainAttrFormTitle": "Attractions Search Form",
                    "mainAttrFormDesc": "Select a city, date range, and attraction type to find activities at your destination. Great for adding extras to any booking.",
                    "mainEvtTabTitle": "Events",
                    "mainEvtTabDesc": "Book tickets to concerts, sports matches, festivals, and more — optionally bundled with flights and a hotel. Click this tab to see the events search form.",
                    "mainEvtFormTitle": "Events Search Form",
                    "mainEvtFormDesc": "Search for events by name or destination and set your dates. Enable \"Full Package\" to bundle the event with a flight and hotel for a complete trip in one booking.",
                    "dynDpSwitchTitle": "Flight + Hotel — Dynamic Package",
                    "dynDpSwitchDesc": "Dynamic Packages combine a hotel of your choice with the lowest available flight for that route — building a competitive, fully-packaged price on the spot. The system automatically locks in the best flight price and pairs it with your hotel results.",
                    "dynDirectTitle": "Direct Flight",
                    "dynDirectDesc": "When enabled, results are limited to direct flights only. Disable to include connecting flights as well.",
                    "dynDepartureTitle": "Departure City",
                    "dynDepartureDesc": "Select the airport or city you will fly from for your dynamic package trip.",
                    "dynDestTitle": "Destination or Hotel Name",
                    "dynDestDesc": "Search broadly by destination city to browse all available hotels in the area — or type a specific hotel name to go straight to that property. Going directly to a hotel is faster when your client already has one in mind, and helps you build the best package in seconds.",
                    "dynDatesTitle": "Stay Dates",
                    "dynDatesDesc": "Choose your hotel check-in and check-out dates.",
                    "dynGuestsTitle": "Rooms & Guests",
                    "dynGuestsDesc": "Add as many rooms as you need and configure each one separately — set the number of adults, children, and infants going into each room. Mix room setups to match your client's group: for example, a family with children in one room and a couple in another.",
                    "dynSearchTitle": "Search Dynamic Package",
                    "dynSearchDesc": "Click to search for available dynamic packages for your chosen destination, dates and guests.",
                    "fltSearchActionTitle": "Search for a Flight",
                    "fltSearchActionDesc": "Fill in your travel details above and click Search to see available flights.",
                    "fltResOnewayDayTitle": "Quick Date Navigation",
                    "fltResOnewayDayDesc": "Use these day cards to quickly jump to another departure date and see updated flight prices instantly.",
                    "fltResOnewayFiltersTitle": "Filter Results",
                    "fltResOnewayFiltersDesc": "Use the side filters to narrow results by airline, price range, number of stops, and flight times.",
                    "fltResOnewayCardsTitle": "Available Flights",
                    "fltResOnewayCardsDesc": "Browse the list of available flights. Each card shows the airline, flight number, duration, stops, and price per passenger.",
                    "fltResOnewayActionTitle": "Select Your Flight",
                    "fltResOnewayActionDesc": "Click \"Select A Flight\" on any card to proceed to the booking details page.",
                    "fltResBundleTabTitle": "Round Trip vs Dynamic",
                    "fltResBundleTabDesc": "Switch between \"Choose your flights yourself\" — including flexible one-way segments and date navigation — and \"Pre-defined flights\" — round trip packages.",
                    "fltResBundleFiltersTitle": "Filter Results",
                    "fltResBundleFiltersDesc": "Use the side filters to narrow results by airline, price range, number of stops, and flight times.",
                    "fltResBundleCardsTitle": "Bundled Flight Options",
                    "fltResBundleCardsDesc": "Each card shows a complete round-trip package with outbound and return flight details and the total price.",
                    "fltResBundleActionTitle": "Move to Order",
                    "fltResBundleActionDesc": "Click \"Move to Order\" on your preferred flight to review the details and add it to your cart.",
                    "fltResBundleResumeActionTitle": "Move to Order",
                    "fltResBundleResumeActionDesc": "Select a bundled flight and click 'Move to Order' to continue.",
                    "fltResDynDayTitle": "Quick Date Navigation",
                    "fltResDynDayDesc": "Use these date cards to jump to a different departure date and see how prices change.",
                    "fltResDynFiltersTitle": "Filter Results",
                    "fltResDynFiltersDesc": "Narrow results by airline, stops, price range, and departure/landing times.",
                    "fltResDynOutboundTitle": "Departure Flights",
                    "fltResDynOutboundDesc": "Browse available outbound flights. Each card shows the airline, route, times, and price per passenger.",
                    "fltResDynOutboundActionTitle": "Select Departure Flight",
                    "fltResDynOutboundActionDesc": "Click 'Select A Flight' on your preferred outbound card to lock it in.",
                    "fltResDynReturnTitle": "Return Flights",
                    "fltResDynReturnDesc": "Now choose your return flight. Browse all available options for your journey home.",
                    "fltResDynReturnActionTitle": "Select Return Flight",
                    "fltResDynReturnActionDesc": "Click 'Select A Flight' to lock in your return leg.",
                    "fltResDynFinalTitle": "Your Selected Flights",
                    "fltResDynFinalDesc": "Both flights are selected. Review the combined price before continuing.",
                    "fltResDynFinalActionTitle": "Move to Order",
                    "fltResDynFinalActionDesc": "Click 'Move to Order' to review the full booking details.",
                    "fltViewAgentCommTitle": "Agent Commission",
                    "fltViewAgentCommDesc": "Review the suggested agent commission for this flight before adding it to the cart.",
                    "fltViewCardTitle": "Flight Details",
                    "fltViewCardDesc": "Review the complete flight information — airline, route, times, stops and baggage options — before booking.",
                    "fltViewPriceTitle": "Price Summary",
                    "fltViewPriceDesc": "The total price is shown per passenger and as a grand total. Agents can also set their commission here before adding to cart.",
                    "fltViewTcTitle": "Terms & Conditions",
                    "fltViewTcDesc": "Review the fare rules and cancellation policy — including important restrictions — before adding to cart.",
                    "fltViewActionTitle": "Add to Cart",
                    "fltViewActionDesc": "Click \"Add to Cart\" to reserve this flight. The cart will open so you can review before checkout.",
                    "fltCartProductsTitle": "Your Cart",
                    "fltCartProductsDesc": "Your cart can hold multiple products of any type — flights, hotels, packages, and more. You can add as many items as you need in a single order. Review everything here before continuing.",
                    "fltCartItemsTitle": "Cart Items",
                    "fltCartItemsDesc": "Each product in your cart is listed here — flight details, room type, dates, and passenger breakdown. Check all items are correct before saving or proceeding.",
                    "fltCartManageBaggageTitle": "Manage Baggage",
                    "fltCartManageBaggageDesc": "Click this button to manage baggage allowances for each passenger — add extra luggage or adjust baggage options for the outbound and return flights separately.",
                    "fltCartDiamondsTitle": "Diamonds Balance",
                    "fltCartDiamondsDesc": "The diamond count shows the cashback reward you will earn from this booking.",
                    "fltCartAgentTitle": "Agent Options",
                    "fltCartAgentDesc": "As an agent, you have full control over your commission on this order. Set a percentage of the total or a fixed amount per person — you decide how much profit you earn on each booking.",
                    "fltCartAgentProfitBtnTitle": "Change Profit",
                    "fltCartAgentProfitBtnDesc": "Click this button to open the profit settings and adjust how your commission is calculated.",
                    "fltCartAgentProfitInputsTitle": "Profit Settings",
                    "fltCartAgentProfitInputsDesc": "Enter a percentage of the total price or a fixed amount per person. The system applies whichever mode is active.",
                    "fltCartAgentSendBtnTitle": "Send Offer",
                    "fltCartAgentSendBtnDesc": "To get a live offer link: first assign a customer to the order, then click Save Offer — that creates the link. Once saved, click here to open the Send Offer panel where you can copy the live link, send it via WhatsApp, or share it by email. The live link gives your customer a real-time view of the order with pricing always up to date.",
                    "fltCartAssignCustomerTitle": "Assign a Customer",
                    "fltCartAssignCustomerDesc": "Click the Assign Customer button to open the customer form and link a customer to this order.",
                    "fltCartAssignModalTitle": "Fill in Customer Details",
                    "fltCartAssignModalDesc": "Fill in the required fields — name, phone, email — and click Save Customer to link them to this order. The modal closes automatically once the customer is saved.",
                    "fltCartCustomerTitle": "Linked Customer",
                    "fltCartCustomerDesc": "The assigned customer is shown here. With a customer linked, you can save the order and share the live offer link — or proceed to checkout on their behalf.",
                    "fltCartCreateOrderTitle": "Save & Share Offer",
                    "fltCartCreateOrderDesc": "Click Save Offer when you're ready — this is only available after assigning a customer. Saving generates a live offer link: when your customer opens it, pricing updates automatically and availability is reflected in real time. You can also send an offer without the live link if you prefer.",
                    "fltCartComparePriceTitle": "Compare Prices",
                    "fltCartComparePriceDesc": "Click to compare this flight's price across other suppliers and find the most competitive option.",
                    "fltCartTotalTitle": "Total Price",
                    "fltCartTotalDesc": "The total price is shown here — including all products and your commission. Once you're satisfied, save the order as an offer to share with your customer, or click Proceed to Payment to continue to checkout.",
                    "fltCartActionTitle": "Proceed to Payment",
                    "fltCartActionDesc": "Click \"Proceed to Payment\" to continue to checkout and fill in the passenger details.",
                    "fltCartSaveOfferActionTitle": "Save Offer to Finish",
                    "fltCartSaveOfferActionDesc": "Click Save Offer to generate the live offer link and complete this step. You can share the link with your client at any time — pricing and availability stay live.",
                    "fltCheckoutCartTitle": "Order Summary",
                    "fltCheckoutCartDesc": "The left panel shows a summary of your selected flight and the total amount to be paid.",
                    "fltCheckoutCustomerInfoTitle": "Client Information",
                    "fltCheckoutCustomerInfoDesc": "Fill in the booker's personal details in this section.",
                    "fltCheckoutFirstNameTitle": "First Name",
                    "fltCheckoutFirstNameDesc": "Enter the booker's first name as it appears on their ID or passport.",
                    "fltCheckoutLastNameTitle": "Last Name",
                    "fltCheckoutLastNameDesc": "Enter the booker's family name as it appears on their ID or passport.",
                    "fltCheckoutPhoneTitle": "Phone Number",
                    "fltCheckoutPhoneDesc": "A valid phone number is required to send confirmation details to the booker.",
                    "fltCheckoutEmailTitle": "Email Address",
                    "fltCheckoutEmailDesc": "Enter the booker's email address to receive the booking confirmation and e-tickets.",
                    "fltCheckoutGuestInfoTitle": "Passenger Details",
                    "fltCheckoutGuestInfoDesc": "Fill in each passenger's full name, passport number, and date of birth exactly as shown on their passport.",
                    "fltCheckoutTCTitle": "Terms & Agreement",
                    "fltCheckoutTCDesc": "Read and accept the booking terms before submitting your order.",
                    "fltCheckoutFormTitle": "Passenger Details",
                    "fltCheckoutFormDesc": "Fill in each passenger's full name, passport number, and date of birth exactly as shown on their passport.",
                    "fltCheckoutActionTitle": "Submit Your Order",
                    "fltCheckoutActionDesc": "Click \"Submit and proceed to payment\" to confirm the passenger details and move to the payment step.",
                    "abBannerTitle": "Agent Control Panel",
                    "abBannerDesc": "This strip at the top of B2C is your exclusive agent control panel. It gives you quick access to customer management, pricing settings, diamonds balance, and your account.",
                    "abExchangeTitle": "Live Exchange Rates",
                    "abExchangeDesc": "Real-time currency rates are shown here for quick reference when working with multi-currency bookings.",
                    "abOnboardingBtnTitle": "Onboarding Guide",
                    "abOnboardingBtnDesc": "Click the question-mark icon at any time to reopen the Onboarding guide and revisit any step you need.",
                    "abSwitchersTitle": "Work Mode Switches",
                    "abSwitchersDesc": "Two toggles: Agent/User mode — when Agent mode is on, commission options and agent-only prices are visible. Gross/Net price — switch between showing the full retail price and the net cost.",
                    "abCustomerSearchTitle": "Customer Search",
                    "abCustomerSearchDesc": "Search for an existing customer by name or details. Selecting a customer links them to the current booking so the order appears in their account and can be managed from the backoffice.",
                    "abUpgradePlanTitle": "Upgrade Your Plan",
                    "abUpgradePlanDesc": "This button appears when your agency is on a Light or Regular plan. Click it to open the plan upgrade dialog and unlock advanced features.",
                    "abDiamondsTitle": "Diamonds Balance",
                    "abDiamondsDesc": "Your cashback balance in Diamonds is shown here. The total includes confirmed earnings plus any future pending rewards. Hover over the icon to see the breakdown.",
                    "abUserMenuTitle": "Your Account",
                    "abUserMenuDesc": "Click your name to open the account menu — view your profile, agency plan status, and log out. Click Finish to complete this step.",
                    "pkgResSearchActionTitle": "Search for a Package",
                    "pkgResSearchActionDesc": "Fill in your travel details above and click Search to see available packages.",
                    "pkgResOverviewTitle": "Search Results",
                    "pkgResOverviewDesc": "Here you can see all available packages matching your search. Each card shows the hotel, travel dates, price, and included flights.",
                    "pkgResSideFiltersTitle": "Filter Results",
                    "pkgResSideFiltersDesc": "Use the side filters to narrow results by price, destination, hotel stars, and more.",
                    "pkgResCardTitle": "Package Card",
                    "pkgResCardDesc": "Each card shows the hotel name, travel dates, flights, included extras, and price per person. Click \"To Order\" to open the full package details.",
                    "pkgResActionTitle": "Open Package Details",
                    "pkgResActionDesc": "Click \"To Order\" on any package card to open the full details in a new tab where you can choose your room and complete the booking.",
                    "pkgPageHotelTitle": "Hotel Information",
                    "pkgPageHotelDesc": "This section shows everything about the hotel in this package — photos, name, star rating, and booking dates.",
                    "pkgPageGalleryTitle": "Hotel Photos",
                    "pkgPageGalleryDesc": "Browse the hotel gallery — click any photo to open the full-size viewer and explore all available images.",
                    "pkgPageDetailsTitle": "Hotel Name & Rating",
                    "pkgPageDetailsDesc": "Here you can see the hotel name, destination, star rating, travel dates, and the total duration of your stay.",
                    "pkgPageIncludesTitle": "What's Included",
                    "pkgPageIncludesDesc": "This area lists everything bundled into the package price — flights, transfers, activities, and event tickets.",
                    "pkgPageFlightsTitle": "Flight Details",
                    "pkgPageFlightsDesc": "This section shows the outbound and return flights included in the package — airline, times, and route.",
                    "pkgPageRoomsTitle": "Choose Your Room",
                    "pkgPageRoomsDesc": "Below are all available room types for this package. Compare options by price, board type, and room features to find the best fit.",
                    "pkgPageRoomFiltersTitle": "Room Filters",
                    "pkgPageRoomFiltersDesc": "Use these filters to narrow options by number of guests, board type (breakfast, half-board, all-inclusive), or room name.",
                    "pkgPageRoomCardTitle": "Room Card",
                    "pkgPageRoomCardDesc": "Each room card shows a photo, the room name, and available facilities. Scroll down inside the card to see all pricing rows.",
                    "pkgPageRoomPriceTitle": "Room Price & Board",
                    "pkgPageRoomPriceDesc": "Each row shows the board plan (breakfast, half-board, etc.), cancellation policy, what is included, and the total price. Choose the option that best fits your client.",
                    "pkgPageAddToCartTitle": "Add Room to Cart",
                    "pkgPageAddToCartDesc": "Click \"Add to Order\" on your chosen room to add this package to the cart and continue to checkout.",
                    "moOrderIdTitle": "Order Reference",
                    "moOrderIdDesc": "Your order number is shown here. Use it to quickly reference this booking when contacting support or tracking the reservation.",
                    "moCartOverviewTitle": "Booking Summary",
                    "moCartOverviewDesc": "The left panel shows your complete booking summary — all reserved products, pricing breakdown, and available actions.",
                    "moCartProductsTitle": "Booked Products",
                    "moCartProductsDesc": "Each item in your order is listed here — flight details, room type, dates, and passenger count. Review all products before making changes.",
                    "moCartAgentTitle": "Agent Options",
                    "moCartAgentDesc": "As an agent, you can adjust your commission on this order — set a percentage or a fixed amount per person. Changes update the total price shown to the customer.",
                    "moCartTotalTitle": "Order Total",
                    "moCartTotalDesc": "The total payable amount is shown at the bottom of the cart. Review it carefully — it reflects all products plus any agent commission applied.",
                    "moTitleAreaTitle": "Page Actions",
                    "moTitleAreaDesc": "The top area of the form shows the page title. The \"Move to Payment\" button lets you proceed to the payment step once you have reviewed and updated the order details.",
                    "moPaymentBtnTitle": "Proceed to Payment",
                    "moPaymentBtnDesc": "Click this button when the order details are complete and correct. You will be taken to the payment section where you can choose a payment method and complete the booking.",
                    "moFormTitle": "Order Details Form",
                    "moFormDesc": "This form lets you review and update all order details — client information, guest names, passport details, and special requests. Fill in all required fields before proceeding to payment."
                },
                "guideExplorer": {
                    "title": "Guide Explorer",
                    "subtitle": "Explore features at your own pace",
                    "startBtn": "Start",
                    "doneLabel": "Done",
                    "noSiteTooltip": "Requires a configured website",
                    "timesCompleted": "times completed",
                    "filtersTitle": "Filters"
                }
            },
            "customerSupport": {
                "customerService": "Customer Service",
                "sendMessageAndGetNotified": "Send us a message and the auctioneer will get back to you as soon as possible",
                "callUs": "Call us: ",
            },
            "roomInfo": {
                "info": "Room Description",
                "viewAllThePhotos": "View all the photos",
                "roomSize": "Room Size (sqm)",
                "peopleInTheRoom": "People in the Room",
                "doubleBed": "Double Bed"
            },
            "conceptsList":{
                "conceptsListTitle": "Concepts List Title",
                "includesActivities": "Gift attractions",
                "includesActivity": "Includes a gift attraction",
                "includeInPackage": "Includes In Package",
                "transfer": "Transfer",
                "includesTransfer": "Includes Transfer",
                "transferContent": "HOS transfers at the price of the package",
                "baseBoard": "Base Board",
                "autoApprove": "Auto Approve",
                "airways": "Airways",
                "flightFrom": "Flight From",
                "flightBack": "Flight Back",
                "landing": "Landing",
                "nights": "Nights",
                "numberOf": "Number of",
                "toOrder": "To Order",
                "noPackagesFound": "No Package Found",
                "moreDeals": "More Deals",
                "pricePerPerson":"Price Per Person",
            },
            "wallet":{
                "enterAmountGreaterThanZero": "Enter an amount greater than 0",
                "notEnoughDiamonds": "Not enough diamonds in your wallet",
                "insufficientBalanceDetail": "Insufficient balance. Available: {available} {currency}, Requested: {requested} {currency}",
                "invalidOrderIdCannotRedeem": "Invalid order id — cannot redeem at this time.",
                "failedToRedeemTryAgain": "Failed to redeem diamonds. Try again.",
                "networkErrorTryAgain": "Network error. Try again.",
                "enterAmount": "Enter amount",
                "ils": "ILS",
                future: "Unrealized earnings",
                creditCard:"Credit Card",
                cancel:"cancel",
                forConfirmationRedemption:"Are you sure you want to redeem",
                TotalDiamondsYouWillReceive:"Total Diamonds You Will Receive",
                max:"Max",
                currentOrderTotal:"current order total",
                MaximumRedeemable:"Maximum redeemable:",
                "UseMax":"Use Max",
                Apply:"Apply",
                Applying:"Applying...",
                RedeemDiamonds:"Redeem Diamonds",
                RemainingDiamonds:"Remaining Diamonds",
                DiscountedValue:"Discounted value",
                RedeemedAmount:"Redeemed amount",
                Redeemed:"Redeemed",
                totalValue:"Total Value",
                diamondsRate:"1 Diamond = 1 ILS",
                availableDiamonds:"Available Diamonds",
                diamondBalance:"Diamond Balance",
                discount:"discount",
                Subtotal:"Subtotal",
                paymentDetails:"Payment Details",
                totalPayment:"Total Payment:",
                "wallet": "Wallet",
                "walletTransactions": "Wallet Transactions",
                "walletBalance": "Wallet Balance",
                "diamonds": "diamonds",
                "diamondsAreAvailableAtYourDisposal": "Diamonds are available at your disposal",
                "paymentWithDiamonds": "Payment with diamonds",
                "returnToOrderManagement": "Return to order management",
                "reserve": "Reserve",
                "finalize": "Finalize",
                "release": "Release",
                "partialRealization": "Partial realization",
                "fullRealization": "Full realization",
                "selectNumberOfDiamondsForPartialUse": "Select number of diamonds for partial use",
                "useAllTheDiamondsIHave": "Using all the diamonds I have",
                "save": "save",
                "confirm": "confirm",
                "forConfirmation": "for confirmation",
                "totalAgentFee": "Total agent fee",

                "dynamicLabels": {
                    'availableDiamondsForPayment': `You have {amount} diamonds available for payment, worth {price}`,
                    'XOfDiamondsWorthY': `{amount} diamonds, worth {price}`,
                    'totalDiamondsYouHaveAccumulatedOverTheLast12MonthsAsOfToday': `Total diamonds you have accumulated over the last 12 months as of today`,
                  },
            },
            "viewFlight":{
                "pleaseSelectDestinationAirport": "Please select Destination Airport",
                "noNearbyAirportFound": "No nearby airport was found. Please search for an airport and ensure it is located close to the hotel",
                "chooseAirportYouWantToArrive": "Choose airport you want to arrive at",
                "chooseAirportYouWantToArriveDescription": "Please consider choosing airport near to the hotel",
                "updateAirport": "Update Airport",
                "flightFrom": "Flight From",
                "flightChange": "Change Flight",
                "totalChange": "Total Change",
                "noFlightsAvailableForSelectedDates": "No availability for flights,  please select different dates",
                "noFlightsForSelectedDatesLocationPassengers": "No flights for the selected dates/location/passengers",
                "show_tickets_with_different_fare_combinations":"Show tickets with different fare combinations",
                "ticketFare":"Fare",
                "ticketInfo":"Ticket info",
                "termsAndConditions": "Terms and Conditions",
                "ifTicketIncludeSeat": " If ticket include seat - client will need to choose it from the airline website",
                "inCaseOfChange": "In case of change - client will need to pay extra money if the updated ticket is higher, also there is additional service fee based on the site Terms & Services",
                "inCaseOfCancellation": "In case of cancellation - it will be additional service fee based on the site Terms & Services",
                "error4305Title": "Oops, the flight is fully booked",
                "error4305Content": "We apologize, but it seems that the seats for this offer are sold out, and we cannot proceed with the purchase. You are being redirected to the main page.",
                "TC": "TC",
                "flights": "Flights",
                "title": "Selected flight, verify details and proceed to payment",
                "addBaggage": "Add baggage",
                "closeAddBaggage": "Hide options",
                "addTrolly": "Add trolley",
                "somethingWetWrong": "Something went wrong",
                "suitcasePrice": "Suitcase price",
                "trollyPrice": "Trolley price",
                "totalPerPassenger": "Total per passenger",
                "updatePassengers": "Update number of passengers",
                "search": "Search",
                "seating": "Seating",
                "cancelation": "Ticket cancellation",
                "meal": "Meals",
                "trolly": "Trolly",
                "suitcase": "Suitcase",
                "changeFlight": "Change ticket",
                "extension": "Extension",
                "totalToBePaid": "Total to be paid",
                "choose": "Choose",
                "checkAmenities":'Check amenities',
                "description":"Description",
                "amenityType":"Amenity type",
                "flightFromAmenities":"Flight from amenities",
                "flightBackAmenities":"Flight back amenities",
                "BAGGAGE": "Baggage",
                "2 CHECKED BAGS UP TO 32KG EACH": "2 Checked bags up to 32kg each",
                "2 CABIN BAGS UP TO 8KG": "2 Cabin bags up to 8kg",
                "BRANDED_FARES": "Branded fares",
                "STANDARD SEAT RESERVATION": "Standard seat reservation",
                "MILEAGE_ACCRUAL": "Mileage accrual",
                "MEAL": "Meal",
                "SNACK": "Snack",
                "COMPLIMENTARY FOOD AND BEV": "Complimentary food and beverages",
                "ENTERTAINMENT": "Entertainment",
                "MAGAZINES / NEWSPAPER": "Magazines / Newspapers",
                "LOUNGE": "Lounge",
                "LOUNGE ACCESS": "Lounge access",
                "TRAVEL_SERVICES": "Travel services",
                "PRIORITY BAGGAGE": "Priority baggage",
                "PRIORITY CHECK IN": "Priority check-in",
                "PRIORITY SECURITY": "Priority security",
                "PRIORITY BOARDING": "Priority boarding",
                "IN FLIGHT ENTERTAINMENT": "In-flight entertainment",
                "PRE_RESERVED_SEAT": "Pre-reserved seat",
                "PRIVACY SEAT BUSINESS CLASS": "Privacy seat business class",
                "CHANGE BEFORE DEPARTURE": "Change before departure",
                "CHANGE AFTER DEPARTURE": "Change after departure",
                "REFUND BEFORE DEPARTURE": "Refund before departure",
                "REFUND AFTER DEPARTURE": "Refund after departure",
                "allFares":"Option to select upgraded ticket",
                "allFaresComment1": "Please note that if the ticket allows changes or cancellations, a handling fee will be charged – please refer to the terms and conditions.",
                "allFaresComment2": "Seat selection, meal choice, and other add-ons can only be managed directly on the airline’s website after booking.",
                "fareChangedSuccessfully":"Fare changed successfully",
                "openFares":"Open fares",
                "selectedFare":"Selected Fare",
                "fullInfo":"Full info",
                "MILEAGE ACCRUAL": "Mileage Accrual",
            },
            "room": {
                "roomSize": "Room Size",
                "bedType": "Bed Type",
                "breakfastIncluded": "Breakfast Included",
                "noAvailabilityOnSelectedDates": "No availability for this room on the selected dates"
            },
            "promotion": {
                "modelNotFound": "Page not found",
                "failToLoad": "Failed to load the page!"
            },
            "searchDatePicker": {
                "dateInPastError": "The selected date has already passed",
                "datesRequiredError": "Please select dates",
                "endBeforeStartError": "The end date must be after the start date",
                "incompleteRangeError": "Please complete the date range",
                "invalidDateError": "The selected dates are invalid",
                "maxStayExceededError": "Hotel stays are limited to 30 nights",
                "showingAllResultsWithin": "Showing all results within",
                "selectDestinationCity": "Select destination city",
                "eventIsInCityCountry": "Your event is in {{city}}, {{country}}",
                "eventIsInCity": "Your event is in {{city}}",
                "nowShowingHotelsInCity": "Now showing hotels in {{city}}",
                "showHotelsNearEvent": "Show hotels near the event",
                'PARTICIPANTS': 'Participants',
                'CITY': 'City',
                'COUNTRY': 'Country',
                'EVENT_TYPE': 'Event Type',
                'TOURNAMENTS': 'Tournaments',
                'VENUES': 'Venues',
                "events":"Events",
                "sportsAndEvents":"Sports and Events",
                checking: "Checking",
                providers: "providers",
                keepScanning: "Keep scanning",
                validatePricesInRealTime: "Validate prices in real time",
                foundSoFar: "Found so far",
                return: "Return",
                calendar:"Calendar",
                cubes:"Cubes",
                requiredFields: "Please fill all required fields: destination, departure, and dates to show results.",
                otherDeparture: "Other Departure",
                departure: "Departure",
                startFrom: "From",
                "freeCancellationTooltipText": "Free Cancellation only applies to the hotel rooms",
                "dynamicPackages": "Dynamic Packages",
                "includeEvents": "Include Events",
                "includeFullPackage": "Include Full Package",
                "allDates": "All dates",
                "choose_packages_according_to": "Choose packages according to",
                "package_hotel_flight": "Package (Hotel + Flight)",
                "package_hotel_flight_events": "Package (Hotel + Flight + Events)",
                "eventDatesOptional": "Event dates (optional)",
                "packageDates": "Package dates",
                "packageDatesMustIncludeEvent": "Package dates must include the event date",
                "noDirectFlightsFound": "No direct flights were found for the selected search",
                "searchWithoutDirectFlight": "Search without direct flight",
                "couldNotLocateDestinationFlights": "We couldn't locate this destination to search for flights",
                "stepEventSelection": "Event selection",
                "stepNights": "Nights",
                "stepPackageSelection": "Package selection",
                "stepDetailsSelection": "Order details",
                "stepBack": "Back to {{step}}",
                "nightsQuestion": "How many nights would you like to stay?",
                "nightsQuestionHint": "Dates are set around the event. Pick a number of nights or adjust the dates below.",
                "yourStay": "Your stay",
                "nightCount": "{{count}} night",
                "nightsCount": "{{count}} nights",
                "nightBeforeEvent": "{{count}} night before the event",
                "nightsBeforeEvent": "{{count}} nights before the event",
                "nightAfterEvent": "{{count}} night after the event",
                "nightsAfterEvent": "{{count}} nights after the event",
                "eventDay": "Event day",
                "adjustYourDates": "Adjust your dates",
                "legendCheckInOut": "Check-in / out",
                "legendStayNights": "Stay nights",
                "legendEventDay": "Event day",
                "hotel_plus_flight": "Hotel + Flight",
                "hotel_plus_flight_events": "Events + Hotel + Flight",
                "tech_stops": "tech stops",
                "freePlanFlightSearchFooterText": "Free plan allows to search Charter flights only!  If you want GDS flights",
                "clickHere": "Click Here",
                "approveSelection": "Approve Selection",
                "attractions":"Attractions",
                "attractions_type":"Types of Attractions",
                "room":"Room",
                'addRoom':"Add Room",
                "removeRoom": "Remove Room",
                "needAnotherRoomAddToCart": "Need another room? Just add to cart.",
                "indirectFlight":"Indirect Flight",
                "directFlightLabel": "Direct Flight",
                "city": "City",
                "hotel": "Hotel",
                "searchForDestination": "Search For Destinations",
                "searchByDestinationAndHotel": "Select Destinations Or Hotels",
                "searchHotelOrDestination": "Search Hotel Or Destination",
                "mapView": "Map View",
                "date": "Date",
                "noResultsForThisDate": "No packages found for this date",
                "searchDestination": "Search destination",
                "pleaseSelectDestination": "Please select a destination",
                "airlineInformation": "Airline information",
                "airlineCode": "Code",
                "title": "Book your dream vacation",
                "hotelOnly": "Search vacation for dates",
                "hotelWithFlight": "Search vacation including flight",
                "oneWay": "One way",
                "roundTrip": "Round trip",
                "selectDate": "Dates selection",
                "startDate": "Start date",
                "endDate": "End date",
                "flights": "Search flights",
                "packages": "Vacation packages",
                "hotels": "Hotels abroad",
                "israelPackage": "Vacation in Israel",
                "specialPackage": "Special packages",
                "passengers": "Passengers",
                "adults": "Adults",
                "adult": "Adult",
                "child": "Child",
                "children": "Children",
                "infant": "Infant",
                "infants": "Infants",
                "infantsWarningMessage": "Infant must be under two years old on the outbound and return flight",
                "select": "Select",
                "noResults": "No results",
                "checkout": "Book now",
                "regularPrice": "Regular price",
                "from": "From",
                "purchase": "Purchase",
                "selectNewFlight": "Select a new flight",
                "search": "Search",
                "rooms": "Rooms",
                "composition": "Composition",
                "chooseComposition": "Choose Composition",
                "numberOfGuests": "Number of Guests",
                "checkOut": "Check Out",
                "checkIn": "Check In",
                "whatVacation": "What kind of vacation",
                "youWant": "do you want",
                "vacationFriendsWith": "Vacation with friends",
                "familyVacation": "Family Vacation",
                "romanticVacation": "Romantic Vacation",
                "notAvailable": "Not Available",
                "roomAvailableDuringTheWeek": "Room availability during the week",
                "followingDates": "Following Dates",
                "vacation": "Vacation",
                "abroad": "Abroad",
                "inIsrael": "In the country",
                "destination": "All destinations",
                "chooseDestination": "Choose destinations",
                "findDreamVacation": "Find your perfect vacation with a click.",
                "searchResTitle": "Choose the right package for you",
                "searchHotelsByNameTitle": "Search by Hotel name for selected destination",
                "directFlight": "Direct Flight",
                "stops": "stops",
                "checkHotel": "Check Hotel",
                "noRating": "No Rating",
                "toOrder": "To Order",
                "selectAgain": "Select Again",
                "selectFlight": "Select A Flight",
                "reselectFlight": "Reselect Flights",
                "flightCanBeReSelectedNextPage": "Flight can be re-selected in the next page",
                "flightSelectedSuccessfully": "Flight Selected Successfully",

                "dynamicFlight": "Dynamic Flight",
                "bundle": "Bundled Flight",
                "freeCancelation": "Free Cancellation",
                "partially_operated_by_airlines": "Partially operated by airlines",
                "connect_in_airport": "Connect in airport",
                "arrives": "Arrives",
                "journey_duration": "Journey Duration",
                "short_wait": "Short Wait",
                "long_wait": "Long Wait",
                "flight_number": "Flight Number",

                "stop_1": "One Stop",
                "activeFlight": "Flight Activated",
                "flightSearch": "Flight Search",
                "nights": "Nights",
                "until": "Until Date",
                "untilYouSearchForFlightDate": "Until Flight Search Date",
                "destinationFrom": "Departure",
                "packageSearch": "Package Search",
                "destinationTo": "Arrival",
                "selectDestination": "Destination",
                "selectDestinationTitle": "Select destination",
                "venueDistanceFromCity": "Venue is {{km}} KM from city center",
                "venueInCity": "Venue is in {{city}}",
                "trollyIsIncluded": "Trolley Included",
                "trollyIsNotIncluded": "Trolley Excluded",
                "suitcaseIsIncluded": "Suitcase Included",
                "suitcaseIsNotIncluded": "Suitcase Excluded",
                "operated_by_airlines": "Operated by",
            },
            "specialDeal": {
                "closeTheDeal": "Close the deal ›",
                "endsIn": "Ends in",
                "specialDealForTheWeekend": "Special deal for the weekend",
                "from": "From date",
                "until": "Until date"
            },
            "footer": {
                "backToTop": "Back to top",
                "allRightsReserved": "© All rights reserved. Do not copy content from the site without permission.",
                "developBy": "Developed by SKY 360 Tech.",
                "thePurchaseOnTheWebsiteIsSecure": "The purchase on the site is secure.",
                "talkToUs": "How to talk to us?",
                "address": "Address",
                "phoneAndWhatsapp": "Phone or WhatsApp",
                "phone": "Phone",
                "whatsapp": "Whatsapp",
            },
            "newsletter": {
                "title": "Subscribe to our Newsletter",
                "subtitle": "Get exclusive deals and travel inspiration",
                "placeholder": "Enter your email",
                "subscribe": "Subscribe",
                "pleaseEnterEmail": "Please enter your email address",
                "somethingWentWrong": "Something went wrong. Please try again."
            },
            "attractions":{
                "showingMoreResults": "Showing More Results",
                "noMoreResults": "No More Results",
                "NoResultsMatchedTheFilterValues": "No Results Matched the Filter Values",
                "inclusions": "Inclusions",
                "exclusions": "Exclusions",
                "overviewOfTheTrip":"Overview of the trip",
                "immediateConfirmation":"Immediate confirmation",
                "pricePerPerson":"Price per person",
                "totalForXXXPeople":"Total for XXX people",
                "toOrder":"To order",
                "freeCancelation":"Free cancelation",
                "showAll":"Show details",
                "hideAll":"Hide details",
                "days": "Days",
                "rating": "Rating",
                "supplier": "Supplier",
                "location": "Location",
                "pricePerPersonFrom": "Price per person from",
                "selectDatesAndTravelers": "Select dates and travelers",
                "bookNowWithFreeCancellation": "Book now with free cancellation",
                "updateSearch": "Update search",
                'activities-health-wellness-spas': 'Spas',
                'activities-action-entertainment-shows-events': 'Shows & events',
                'activities-nature-outdoors-zoos-aquariums': 'Zoos & aquariums',
                'activities-food-drink': 'Food & drink',
                'activities-action-entertainment-shopping': 'Shopping',
                'activities-nature-outdoors-tickets-passes': 'Tickets & passes',
                'activities-action-entertainment-rentals-rides': 'Rentals & rides',
                'activities-transportation': 'Transportation',
                'activities-culture-shows-events': 'Shows & events',
                'activities-nature-outdoors': 'Nature & outdoors',
                'activities-tours-by-theme-shopping-tours': 'Shopping tours',
                'activities-workshops-classes-sport-lessons': 'Sport lessons',
                'activities-action-entertainment-tickets-passes': 'Tickets & passes',
                'activities-workshops-classes-music-dance': 'Music & dance',
                'activities-food-drink-workshops-classes': 'Workshops & classes',
                'activities-health-wellness-relaxation': 'Relaxation',
                'activities-tours-by-theme-food-drink-tours': 'Food & drink tours',
                'activities-workshops-classes': 'Workshops & classes',
                'activities-health-wellness-beauty-treatments': 'Beauty treatments',
                'activities-action-entertainment-water': 'Water',
                'activities-workshops-classes-arts-crafts': 'Art & crafts',
                'activities-tours-by-theme': 'Tours by theme',
                'activities-action-entertainment-land': 'Land',
                'activities-tours-by-theme-sport-tours': 'Sport tours',
                'activities-culture': 'Culture',
                'activities-tours-by-theme-walking-tours': 'Walking tours',
                'activities-health-wellness-alternative-medicine': 'Alternative medicine',
                'activities-tours-by-theme-art-culture-tours': 'Art & culture tours',
                'activities-workshops-classes-cultural-immersion': 'Cultural immersion',
                'activities-health-wellness': 'Health & wellness',
                'activities-nature-outdoors-air-activities': 'Air activities',
                'activities-tours-by-theme-luxury-tours': 'Luxury tours',
                'activities-tours-by-theme-historical-heritage-tours':
                  'Historical heritage tours',
                'activities-culture-art-culture-tours': 'Art & culture tours',
                'activities-action-entertainment-air': 'Air',
                'activities-tours-by-theme-nature-wildlife-tours':
                  'Nature & wildlife tours',
                'activities-tours-by-theme-discovery-tours': 'Discovery tours',
                'activities-nature-outdoors-wildlife-nature-observation':
                  'Wildlife & nature observation',
                'activities-action-entertainment': 'Action & entertainment',
                'activities-tours-by-theme-museum-exhibition-tours':
                  'Museum & exhibition tours',
                'activities-workshops-classes-food-drink': 'Food & drink',
                'activities-tours-by-theme-virtual-tours': 'Virtual tours',
                'activities-tours-by-theme-special-tours': 'Special tours',
                'activities-nature-outdoors-land-activities': 'Land activities',
                'activities-transportation-rentals-rides': 'Rentals & rides',
                'activities-nature-outdoors-water-activities': 'Water activities',
                'activities-food-drink-restaurants-bars': 'Restaurants & bars',
                'activities-food-drink-food-drink-tours': 'Food & drink tours',
                'activities-no-category': 'No Category',
                'activities-health-wellness-retreats': 'Retreats',
                'activities-action-entertainment-sport-lessons': 'Sport lessons',
                'activities-tours-by-theme-self-guided-tours': 'Self-guided tours',
                'activities-action-entertainment-multi-adventure-games':
                  'Multi-adventure & games',
                'activities-food-drink-tickets-passes': 'Tickets & passes',
                'activities-tours-by-theme-night-tours': 'Night tours',
                'activities-culture-tickets-passes': 'Tickets & passes',
                'activities-transportation-transfers': 'Transfers',
                "hours": "Hours",

                "ages_between_min_max_range": `Ages Between {min_max_range}`,
                "ages_between": `Ages Between`,
                "sum_price_amount": `Sum Price: {amount}`,
                "sum_price": `Sum Price:`,
            },
            "sportsAndEvents": {
                "atLeastOneTicketMustBeSelected": "At least one ticket must be selected",
                "dateNotFinal": "Date not final",
                "timeNotFinal": "Time not final",
                "dateAndTimeNotFinal": "Date and time not final",
                "dateIsSubjectToChange": "Date is subject to change",
                "timeIsSubjectToChange": "Time is subject to change",
                "dateAndTimeAreSubjectToChange": "Date and Time are subject to change",
                "onlyAFewTicketsLeft": "Only a few tickets left",
                "pricePerTicket":"Price per ticket",
                "priceDifference": "Price Difference",
                "serviceFee": "Service fee",
                "totalPrice": "Total Price",
                "cannotChangeSeatingFromThisPage": "You can update ticket category in the next phase",
                "reselectSeating": "Reselect Seating",
                "sportsAndEvents": "Sports and Events",
                "noTitle": "Event",
                "comingSoon": "Coming Soon!",
                "noTicketsAvailable": "No tickets available",
                "selectTickets": "Select Tickets",
                "notifyMe": "Notify me",
                "notifyMeDescription": "Enter your email to be notified when tickets become available",
                "notifyMeEmailPlaceholder": "Enter your email address",
                "notifyMeSubmit": "Notify me",
                "notifyMeSuccess": "You will be notified when tickets become available",
                "notifyMeError": "Failed to submit notification. Please try again.",
                "notifyMeEmailRequired": "Please enter your email address",
                "notifyMeEmailInvalid": "Please enter a valid email address",
                "tournament": "Tournament",
                "participants": "Participants",
                "eventType": "Event Type",
                "vipPackage": "VIP Package",
                "hold24Hours": "24h Hold Available",
                "instantConfirmation": "Instant Confirmation",
                "offlineStock": "Offline Stock",
                "rating": "Rating",
                "location": "Location",
                "dateTimeSeparator": " at ",
                "viewOnMap": "View on Map",
                "selectQuantity": "Select Quantity",
                "avenue": "Avenue",
                "venue": "Venue",
                "city": "City",
                "country": "Country",
                "state": "State",
                "zip": "Zip",
                "latitude": "Latitude",
                "longitude": "Longitude",
                "whereWillISit": "Where will I sit?",
                "seatingArrangements": "Seating arrangements",
                "seatingInPairs": "Seating in pairs",
                "seatingInPairsDescription": "We are committed to seat you in pairs (Two together) unless the ticket category specifically indicates otherwise.",
                "seatingInPairsNote": "PLEASE NOTE: in some stadiums (Most notably Barcelona's Camp Nou and Real Madrid's Santiago Bernabéu) \"seating in pairs\" includes diagonal or perpendicular adjoined seats.",
                "seatingThreeTogether": "Seating three together or more",
                "seatingThreeTogetherDescription": "When you need three tickets or more we'll do our best to seat you together; however, we cannot guarantee it.",
                "seatingThreeTogetherNote": "If you MUST sit together, kindly check availability with our customer service team, by phone or e-mail. In most cases we will be able to confirm a specific request or offer an alternative solution.",
                "homeFansOrAwayFans": "Home fans or away fans",
                "homeFansDescription": "All the tickets are for the Home section, unless indicated otherwise (\"Away section\").",
                "homeFansBehaviorCode": "According to the organizer's behavior codes, you are not allowed to cheer the away team or wear any away-team colors. Participants are also advised to wear neutral-colored clothing if not supporting the home team. Not following these rules may be interpreted as a provocation and might get you expelled from the stadium.",
                "neutralVenueNote": "The above specifications do not apply to matches that are played at a Neutral Venue/Stadium‏ (such as Champions League Final, Europa League Final, FA Cup Final, League Cup Final or World Cup events). Unless specified otherwise, the seats can be located in either one of the sections, so you are advised to wear neutral-colored clothing.",
                "singleTickets": "Single tickets",
                "singleTicketsDescription": "We sometimes offer tickets that are specifically categorized as \"single\".",
                "singleTicketsNote": "These tickets are usually cheaper, but they are what they are – single. If you buy two \"Single\" tickets you will not seat together.",
                "groupSeating": "Group seating",
                "groupSeatingDescription": "For 8 tickets or more kindly check the availability for group seating and the price with our customer service team, by phone or e-mail. Group seating may be found to cost less, or more, depending on the availability.",
                "groupSeatingNote": "If the ticket category you chose allows it – you can go ahead and place the order without contacting us first, but please remember, in such a case we can only guarantee to seat you in pairs.",
                "pleaseNote": "Please note",
                "pleaseNoteDescription": "The information above about the seating arrangements is generic and in general may not match the exact description of the ticket you've chosen. When available, we present the relevant seating chart or venue map.",
                "pleaseNoteConsult": "Please consult it when reviewing the ticket categories for this event.",
                "haveMoreQuestions": "Have more questions?",
                "contactUsForInfo": "For further information please feel free to Contact Us",
                "eventLoadError": "Failed to load event details",
                "quantity": "Quantity",
                "deliveryMethod": "Delivery Method",
                "selectDeliveryMethod": "Select Delivery",
                "ticketsAvailable": "tickets available",
                "available": "Available",
                "quantityCannotBeZero": "Quantity cannot be 0",
                "deliveryMethodNotFound": "Delivery method not found",
                "purchaseAlertTitle": "Important Notice",
                "purchaseAlertAgree": "Agree",
                "purchaseAlertGoBack": "Go Back",
                "showDescription": "Show description",
                "hideDescription": "Hide description",
                "deliveryFree": "Free",
                "deliveryMethodDescription": "Delivery method description",
            },
            "packages": {
                "tour": 'Organized Tour',
                "availableSeats":"Available seats",
                "from": "From date",
                "until": "Until date",
                "breakfastIncluded": "Breakfast Included",
                "includesMassageAndSpa": "Includes massage and spa!",
                "lastRoom": "Last room!",
                "includesTransfers": "Includes transfers",
                "includesActivities": "Includes attractions",
                "nights": "Nights",
                "withoutBaggage": "Without luggage",
                "directFlight": "Direct flight",
                "oneStop":"One Stop",
                "numOfStops":"Stops",
                "flightDetails": "Flight details",
                "flightFrom": " from -> to",
                "flightBack": " from -> to",
                "hours": "Hours",
                "flightNumber": "Flight number",
                "airLine": "Airline",
                "suitcaseWeight": "weightkg Baggage Included",
                "trollyWeight": "weightkg Trolley included",
                "includedActivitiesTitle": "Attractions and tours in the package",
                "checkAllPictures": "View all the pictures",
                "affiliateWith": "In collaboration with",
                "addButtonDisabledTooltip": "Order is limited to room quantity - cannot add another room. To change a room, remove a room from the cart",
                "holidaySchedule": "Vacation schedule",
                "passengers":"Passengers",
                "isRoundTrip": "Baggage Price for Round Trip *",
                "includesFlights": "Includes Flights",
                "includesEventTicket": "Includes Event Ticket",
                "returnFlight": "Return Flight",
                "outboundFlight": "Outbound Flight",
                "trollyWeight2": "weight kg trolley / bag",
                "suitcaseWeight2": "weight kg suitcase",
                "included": "Included",
                "notIncluded": "Not Included",
                "perPax": "Per Passenger",
                "addSuitcaseLater": "You can add later",
                "clickForDetails": "Click Here for Attraction Details",
                "includedInPackage": "Included in the Package!",
            },
            "roomPricing": {
                "noRoomsAvailable": "No rooms available for the selected dates and guests.",
                "noRoomsAvailableForSelectedDates": "No availability for rooms, please select different dates",
                "for": "for",
                "addPassenger": "Add Passenger",
                "pricePerPerson": "Price per person",
                "pricePerRoom": "Price per room",
                "priceForAllRooms": "Price for all rooms",
                "payOnSpot": "Pay On Spot",
                "resort_fee": "Resort Fee",
                "occupancy_tax": "Occupancy Tax",
                "totalPrice": "Total Price",
                "pricePerInfant": "Price per infant",
                "composition": "Composition",
                "adultsInTheRoom": "Adults",
                "children": "Children",
                "adults": "Adults",
                "single": "Single adult",
                "child": "Child",
                "selectInfantCount": "Select from the list",
                "infant": "Infant",
                "1infant": "One infant",
                "2infants": "2 infants",
                "infants": "Infants",
                "noInfants": "Without infants",
                "all_include": "All inclusive",
                "breakfast": "Breakfast",
                "activities": "Choose a tour",
                "half_board": "Half board",
                "half_board_kosher": "Kosher half board",
                "full_board": "Full board",
                "sleep_only": "Room Only",
                "breakfast_kidush": "Friday morning and evening meal",
                "addToCard": "Add to order",
                "inPackageDates": "In package dates",
                "chooseRoom": "Choose room composition",
                "nights": "Nights",
                "boardType": "Board basis",
                "filters": "Filters",
                "freeCancellation": "Free Cancellation",
                "roomInfo": "Room Info",
                "noAvailableRooms": "No rooms available for the selected dates",
                "noAvailableRoomsForDates": "Room not available for the selected dates",
                "addInfant": "Add infant",
                "roomFacilities": "Room Facilities",
                "show_images": "Show Images",
                "autoApprove": "Auto Approve",
                "includedInPrice": "Included in Price",

                "until": "Until",
                "no": "No",
                "vat": "Vat",
                "is": "Is",
                "not": "Not",
                "city_tax": "City Tax",
                "cancellation_policy": "Cancellation Policy",
                "your_local_time": "*Your local Time",
                "additional_price_info": "Additional Price Info",
                "policy": {
                    "freeCancallationUntil": "Free cancellation at this rate until",
                    "freeCancallationUntil2": "Free Cancellation Until",
                    "cancallationBeCharged": "You will be charged",
                    "ifYouCancelBetween": "If you cancel from",
                    "ifYouCancelModifiedBetween": "If you cancelled or modified after",
                    "cancelFullPrice": "full price of the reservation will be charged",
                    "till": "till",
                    "rateNonRefundable": "The rate is non-refundable upon cancellation",
                },
            },
            "boards" : {
                "RO": "ROOM ONLY",
                "BB": "BED AND BREAKFAST",
                "HB": "HALF BOARD",
                "FB": "FULL BOARD",
                "AI": "ALL INCLUSIVE",
                "UI": "ULTRA DELUXE ALL INC",
                "BF": "BUFFE BRAKFAST",
                "KB": "COLD BUFFET BREAKFAST",
                "KBB": "Kosher Breakfast",
                "CB": "CONTINENTAL BREAKFAST",
                "AB": "AMERICAN BREAKFAST",
                "DR": "DINNER AND ROOM",
                "EB": "ENGLISH BREAKFAST",
                "FT": "FB+TREATMENTS",
                "F+": "FULL BORD PLUS",
                "GA": "GALA DINNER",
                "H6": "HB+ONLY 6 TREATMENTS",
                "HT": "HB+TREATMENTS",
                "IB": "ISRAELI BREAKFAST",
                "KO": "KOSHER",
                "KS": "OSHER BREAKFAST",
                "MI": "MAX ALL INCLUSIVE",
                "RB": "ROOM & BREAKFAST",
                "NN": "SEE ITINERARY",
                "SI": "SOFT ALL INCLUSIVE",
                "UL": "ULTRA ALL INCLUSIVE",
                "half_board": "Half board",
                "half_board_kosher": "Kosher half board",
                "full_board": "Full board",
                "sleep_only": "Room Only",
                "breakfast_kidush": "Friday morning and evening meal",

                "breakfast": "BB",
                "breakfast-for-2": "BB for 2",
                "nomeal": "Room Only",
            },
            "activitiesTranslations": {
                "addToOrder": "Add to order",
                "passenger": "To the passenger",
                "showMore": "Show more",
                "addAttractionsAndTrips": "Add attractions and trips",
                "doYouWantToAddAttractions": "Do you want to add attractions to your vacation?",
                "itsTime": "It's time!",
                "pricePerPerson": "Price per person",
            },
            "modal": {
                "viewAllImages": "View all images",
                "galleryTitle": "Photo gallery",
                "cancelationTerms": "Cancellation terms - ",
                "nameOfTheHotel": "Hotel details",
                "hotelInfo": "About the hotel",
                "hotelWebsite": "Link to the hotel website",
                "showMore": "Show More",
                "showLess": "Show Less",
            },
            "manageBaggage":{
                'manageBaggage':"Manage baggage",
                "and":"And",
                "save":"Save",
                "purchaseIsNotSupported":"purchase is not supported",
                "baggageIsForBothFlights":"You can add baggage for a round trip flight",
                "suitcase": "Suitcase",
                "trolly": "Trolley",
                "guest":"Guest"
            },
            "shoppingCartTranslations": {
                "attachCompleteFromCheckout": "This cart will be attached to the existing order — complete it from the checkout page",
                "beingReplaced": "Being replaced",
                "attachModeReplace": "Replace product",
                "attachModeAdd": "Add product",
                "attachReplacingFor": "Choosing a replacement for",
                "attachAddingTo": "Adding a product to order",
                "attachOnOrder": "on order",
                "attachClient": "client",
                "attachCancel": "Cancel",
                "attachCurrencyConverted": "The selected product is priced in {product_currency} and will be added to the order in {order_currency} at today's rate",
                "attachConfirmTitle": "Editing an existing order",
                "attachConfirmReplaceExplanation": "You are in replace-product mode on an existing order. The product you select will replace the product on the original order.",
                "attachConfirmAddExplanation": "You are in add-product mode on an existing order. The product you select will be added to the original order.",
                "attachConfirmQuestion": "Do you want to continue in this mode?",
                "attachConfirmContinue": "Continue",
                "attachConfirmCancelMode": "Cancel mode",
                localInventoryAlert: "Order with  speciel package, currently not supported for view - just for payment",
                skyInventory: "SKY Inventory",
                recommendedHotel: "Recommended hotel",
                recommendedFlight: "Recommended flight",
                "dynamicPackageTitleRemark": "Price include Flight + Hotel - each product has it's own terms & conditions",
                "dynamicPackageTitleRemarkEvents": "Price include Flight + Hotel + Event - each product has it's own terms & conditions",
                "productIsApproved": "This product has been approved",
                "productIsNotApproved": "This product was not approved",
                "waitingToApprove": "This product is being processed",
                "productIsCancelled": "This product has been Cancelled",
                "orderIsApproved": "This order has been approved!",
                "orderIsNotApproved": "This order was not approved!",
                "orderBeingProcessed": "This order is being processed",
                "orderIsCancelled": "This order has been Cancelled!",

                'attractionPriceDescription': "Attraction price depends on date, option selection and amount of ticket",
                'selectedDate': "Selected Date",
                'selectADate': "Select a Date",
                'availableDatesBetween': "Available Dates Between",
                'Options': "Options",
                'Text': "Text",
                'Ticket type': "Ticket type",
                'Start Time': "Start Time",
                'Guide language': "Guide language",
                'Pick Up Location': "Pick Up Location",
                'Custom Pick Up Location': "Custom Pick Up Location",
                'Drop Off Location': "Drop Off Location",
                'Custom Drop Off Location': "Custom Drop Off Location",

                'manageBaggage':"Manage baggage",
                "youCanAddGuestsOnlyUpToTheAvailableSeats":"You can add guests only up to the available seats",
                "paxExceedsAuthorizedSeats": "The number of passengers exceeds the number of seats authorized at this fare – please note that the booking will be in request and that the price is subject to change",
                "paxExceedsAvailableSeats": "The number of passengers exceeds the available number of seats – please note that the booking will be submitted as pending supplier approval and that the price may change",
                "shoppingCartButtonTooltip": "Choose a composition and add to order",
                "totalPrice": "Total payment",
                "proceedToPayment": "Proceed to payment",
                "placeOrder": "Proceed to registration",
                "NoHotelWasChosenForTheVacation": "No hotel was chosen for the vacation",
                "betweenDates": "Between the dates",
                "packageInformation": "Package details",
                "rooms": "Room details",
                "transfers": "Transfers",
                "round_trip_transfers": "Round-trip hotel transfers/shuttles",
                "reg_transfers": "Transfers/shuttles to and from the hotel",
                "shuttle_transfers": "Shuttles from the border to the hotel and back",
                "flights": "Flights",
                "activities": "Attractions",
                "details": "Details",
                "shoppingCart": "Shopping Cart",
                "package": "Nights at the hotel",
                "nights": "Nights",
                "inHotel": "In the hotel",
                "apply": "Confirm",
                "promoCode": "Coupon code",
                "yourShoppingCart": "Your Shopping Cart",
                "isEmpty": "Still empty...",
                "myVacation": "My vacation",
                "showAll": "Show all »",
                "beforeDiscount": "Total before discount -",
                "agentCommission": "Agent commission -",
                "agentCommissionNet": "Agent commission (net payment) -",
                "discountFromCode": "Code discount -",
                "affiliateWith": "In collaboration with -",
                "tpId": "Order ID -",
                "chargeTypeFullCC": "Full payment - including commission",
                "chargeTypeNetCC": "SubscriptionPayment for net price",
                "chargeTypeCash": "Cash transaction",
                "agentCommissionPrec": "Agent commission percentage",
                "priceOff": "Discount",
                "percentageOff": "Discount percentage",
                "selectedItems": "Selected items",
                "viewProduct": "View Product",
                "view": "View",
                "infantAdditionalPrice": "Infant additional price",
                "netPriceWarning": "Net Price, Please add profit!",
                "copyOrderLink": "Copy Link",
                "createOrder": "Save Offer",
                "createOrderError": "Failed to save the offer, please try again",
                "updateCommission": "Save",
                "commissionNotSaved": "Please click to save!",
                "clearCart": "Click to clear cart",
                "assignCustomer": "Assign Customer",
                "firstName": "First Name",
                "lastName": "Last Name",
                "phone": "Phone",
                "comment": "Comment",
                "email": "Email",
                "wrongEmailFormat": "Incorrect email format",
                "saveCustomer": "Save customer",
                "updateCustomerTitle": "Update customer",
                "createCustomerTitle": "Create new customer",
                "avgPricePerPerson": "Add average price per person",
                "avgPricePerPersonLine": "Average price per person",
                "totalPaxLabel": "Pax",
                "sendByWhatsApp": "Send by WhatsApp",
                "copyText": "Copy Text",
                "copyQuoteTakanonLine": "Please make sure you have read and approved the terms and conditions before purchasing\nLink to terms and conditions: {domain}/takanon",
                "copyWithOrgDays": "Copy Full Offer with Org Days Info",
                "orgItineraryHeader": "Itinerary",
                "orgTourPackageLine": "Organized tour to {destination}, Tour name: {tourName}, {nights}, {dateStart} - {dateEnd}",
                "packageToDestinationLine": "Vacation package to {destination}",
                "sendBySMS": "Send by SMS",
                "findQuoteFor": "Send Offer via",
                "linkIsGive": "Quote is Live",
                "dates": "Dates",
                "hotelName": "Hotel name",
                "flightPrice": "Flight price",
                "suitcase": "Suitcase",
                "trolly": "Trolley",
                "passengers": "Passengers",
                "totalAgentComm": "Total agent commission",
                "agentOptions": "Agent Options",
                "compareDisableForAgent": "Price comparison is available when there are 2 quotes in the cart",
                "createNewUser": "Create New Offer",
                "comparePrice": "Compare Prices",
                "send": "Send Offer",
                "profitPercentageChange": "Change Profit",
                "or": "Or",
                "approval": "Approval",
                "profitPerPerson": "Profit per person",
                "grossProfitPercentage": "Percentage Profit",
                "grossProfitPercentageInvalidRange": "Profit percentage must be between 0 and 99",
                "commissionMixedCurrencyTitle": "How the commission was calculated",
                "commissionMixedCurrencyNote": "The commission is split across the items below and added in each one's own currency, then converted.",
                "commissionFlightLabel": "Flight",
                "commissionRoomLabel": "Room",
                "commissionTotalLabel": "Total",
                "actionNotAllowed": "Action not allowed",
                "orderIsAlreadySaved": "Order is already saved and no additional products can be added",
                "clickToClear": "Click to clear the cart",
                "roomsByRequestSubjectOfHotelAvailability": "Unable to add the same type and composition of room, please select a different type of room",
                "roomApprovalIsSubjectToRoomAvailability": "Room approval is subject to room availability",
                "unableToAddRoomToSamePackage": "Unable to add the room to the same package",
                'roomsByRequestSubjectOfHotelAvailabilityTitle':"Failed to add room",
                "youReachedMaxRooms": "You reached max rooms",

                "eventTicketAlreadyAdded": "Unable to add the same type of ticket, please select a different type of ticket",
                'failedToAddEventTicket':"Failed to add event ticket",
                "eventTicketPaxMismatchTitle": "Event ticket and passenger count do not match",
                "eventTicketPaxMismatch": "The number of selected event tickets does not match the number of passengers (flight/room). Please update the event ticket quantity or room selection.",

                "attractionAlreadyAdded": "Unable to add the same type of attraction, please select a different type of attraction",
                'failedToAddAttraction':"Failed to add attraction",
                "noAvailabilityOnThisDates": "No availability for selected dates",
                "attractionSearchFailed": "Attraction Search Failed",
                "cannotSearchForThePastDates": "Cannot Search For The Past Dates",
                'searchOtherForDates':"There is no availability, please search for other available dates",
                "adult": "Adult",
                "child": "Child",
                "infant": "Infant",
                "perPerson": "Per Person",
                "perVehicle": "Per Vehicle",
                "group": "Group",
                "family": "Family",
                "perEquipment": "Per Equipment",
                "perBoat": "Per Boat",
                "none": "None",
            },
            "checkout": {
                "adult": "Adult",
                "child": "Child",
                "infant": "Infant",
                "adultMinAgeError": "Adult guests must be at least 12 years old",
                "expirationDateMustBeFuture": "Expiration date must be after today",
                "failedToUpdateCommission": "Failed to update commission",
                "orderTotalIncreasedBy": "Order total increased by {amount}.",
                "orderTotalDecreasedBy": "Order total decreased by {amount}.",
                "amountDueLabel": "Amount due: {amount}.",
                "attachUpdateOrderBtn": "Update order",
                "attachAddToOrderBtn": "Add to order",
                "attachReplaceNotice": "You are updating an existing order — the replaced product will be removed and the new one attached on save",
                "attachAddNotice": "You are updating an existing order — the new product will be attached on save",
                "productReplacedOnOrder": "Product replaced on order",
                "productAddedToOrder": "Product added to order",
                "noNewProductsToAttach": "No new products in the cart — pick the product to add first",
                "countryOfBirth": "Country of Birth",
                "cityOfBirth": "City of Birth",
                "nationalityCountryId": "Nationality Country",
                "passportNumber": "Passport Number",
                "fill_out_at_least_one_guest_fields": 'Please fill out all fields for at least one guest!',
                "addRestOfGuests": "Add Rest Of Guests",
                "hideRestOfGuests": "Hide Rest Of Guests",
                "addBaggage":"Add Baggage",
                "newGuest":"New guest",
                "selectGuest":"Select Guest",
                "chooseExistingGuest":"Use existing guest",
                "noMatchingGuests":"No matching guests",
                "insertGuests": {
                  "inputHint": "Enter a previous order to reuse its guests here.",
                  "button": "Insert guests from old order",
                  "title": "Insert guests from another order",
                  "orderIdLabel": "Order ID",
                  "orderIdPlaceholder": "Enter the order ID",
                  "load": "Load order",
                  "notFound": "Order not found",
                  "accessDenied": "You don't have permission to access this order",
                  "noGuests": "No guests found in this order",
                  "previewTitle": "Review how guests will be inserted",
                  "summary": "Guests are matched by type. Loaded guests take priority and overwrite the matched slot.",
                  "empty": "Empty",
                  "noMatch": "No matching guest",
                  "leftover": "guest(s) could not be placed — no free slot of that type",
                  "guestLabel": "Guest",
                  "doNotInsert": "Don't insert",
                  "reassign": "reassign",
                  "noSlotForType": "No matching guest to swap",
                  "unassignable": "guest(s) can't be inserted — no matching type in this order",
                  "loadedGuest": "Loaded guest",
                  "currentGuest": "Current guest to replace",
                  "chooseSlot": "Choose guest to replace",
                  "noFreeSlot": "No free slot — uncheck another guest first",
                  "countInsert": "to insert",
                  "countExcluded": "excluded",
                  "countNoMatch": "no match",
                  "apply": "Insert selected",
                  "back": "Back"
                },
                "additionalBaggage": "Additional Baggage",
                "free": "free",
                "baggageIsForBothFlights":"You can add baggage for a round trip flight",
                "additionalBaggageForThisGuest": 'Additional Baggage For This Guest',
                "orderFailedToLoad":"An error occurred while loading the offer",
                "cartNoLongerValid":"The cart is no longer valid",
                "room": "Room",
                "personalInfo": "Order Details",
                "roomNoLongerAvailable": "{rooms} is no longer available and must be removed from the order.",
                "unavailableProductsTitle": "Some products in this order are no longer available",
                "productNoLongerAvailable": "{products} is no longer available.",
                "productCouldNotBeConfirmed": "{products} could not be confirmed.",
                "productUnavailableBadge": "No longer available",
                "productUnconfirmedBadge": "Could not be confirmed",
                "paymentBlockedUnavailable": "This order cannot be paid until the unavailable products are resolved. Please contact us to update your booking.",
                "totalPendingRefresh": "The price will be updated once the unavailable products are removed",
                "orderCannotBeShown": "This order cannot be shown right now.",
                "retryLoad": "Try again",
                "paymentDetails": "Payment",
                "orderCompletion": "Finish Order",
                "userDetails": "Client info",
                "name": "First Name",
                "lastName": "Family Name",
                "passport": "Passport",
                "inEnglish": "",
                "birthdate": "Birthdate",
                "phone": "Phone",
                "email": "Email",
                "notesForTheOrder": "Notes for the order",
                "namesOfGuests": "Passengers",
                "namesMustMatchPassport": "* All names must be typed in English exactly as they appear on the passport",
                "goToPayments": "Submit and proceed to payment",
                "saveAndCommit": "Save and Commit to Offer",
                "saveAndPayLater": "Save & Pay Later",
                "saveOrder": "Save order",
                "agreement": "I confirm the website's terms, order terms, and the order cancellation terms",
                "men": "Male",
                "women": "Female",
                "pleaseInputYourPhone": "Please enter phone number",
                "pleaseInputYourLastName": "Please enter last name",
                "pleaseInputYourFirstName": "Please enter your first name",
                "pleaseInputYourEmail": "Please enter your email",
                "pleaseInputYourPassportNumber": "Please enter your passport number",
                "pleaseInputYourDateOfBirth": "Please enter date of birth",
                "pleaseSelectGender": "Please select gender",
                "yourPhone": "Phone number",
                "yourLastName": "Last name",
                "yourFirstName": "First name",
                "yourEmail": "Email",
                "yourDateOfBirth": "Date of birth",
                "yourGender": "Gender",
                "maxChildAge": "Child between the ages 2-",
                "maxInfantAge": "Infants must be under two years old at the time of the vacation",
                "pleaseAgreeWithT&C": "Please agree to the terms of use and website regulations",
                "viewTerms": "View regulations",
                "invalidEmail": "Invalid email",
                "orderCreateSuccess": "Your order has been saved successfully, you are being redirected to payment",
                "orderCreateFree": "Your order has been saved successfully!",
                "orderUpdateSuccess": "Your order has been updated successfully!",
                "mainRoomGuestTitle": "Room named after",
                "uploadPassportImage": "Upload passport photo",
                "addInfant": "Add infant",
                "updateInfant": "Update infant quantity",
                "howManyInfantsDoYouWantToAdd": "Choose the number of infants for this room",
                "add": "Add",
                "setInfantCountForRoom": "Update infant quantity",
                "setInfantCountForRoomSuccess": "The number of infants has been updated successfully",
                "infantsAddedToTheRoom": "Infants added to the room",
                "selectNumberOfInfants": "Choose number of infants",
                "pricePerInfant": "Price per infant",
                "infantsRemoved": "Infants were removed from this room",
                "requiredUploadPassportImage": "Uploading passport photo is mandatory",
                "infantError4403": "Cannot change the number of infants - please contact the service center",
                "docketId": "* Docket ID",
                "agencyId": "* Agency ID",
                "documentType": "Document Type",
                "documentTypeInfo": "Choose ID Card for domestic flights",
                "documentTypePassport": "Passport",
                "documentTypeIdCard": "ID Card",
                "issuingCountry": "Issuing Country",
                "residenceCountry": "Residence Country",
                "nationality": "Nationality",
                "documentNumber": "Document Number",
                "documentNumberPassport": "Passport Number",
                "documentNumberIdCard": "ID Card Number",
                "pleaseInputPassportNumber": "Please enter passport number",
                "pleaseInputIdCardNumber": "Please enter ID card number",
                "expirationDate": "Expiration Date",
                "pleaseSelectDocumentType": "Please select document type",
                "pleaseSelectIssuingCountry": "Please select issuing country",
                "pleaseSelectResidenceCountry": "Please select residence country",
                "pleaseSelectNationality": "Please select nationality",
                "pleaseInputDocumentNumber": "Please enter document number",
                "pleaseSelectExpirationDate": "Please select expiration date",
                "noTrolly": "No trolley",
                "noSuitcase": "No suitcase",
                "updateBaggages": "Update baggage",
                "manageBaggagesFor": "Manage baggage for guest",
                "closeAddBaggage": "Hide options",
                "close": "Close"
            },
            "manageOrder": {
                moveToPaymentWarning:'Client Info not saved and Guests Info are empty! Are you sure you want to continue?',
                moveToPaymentWarning1:'Client Info not saved. Are you sure you want to continue?',
                moveToPaymentWarning2:'Guests Info are empty! Are you sure you want to move to payment?',
                "questions": "Questions",
                "moveToPayment": "Add Payment",
                "backToManage": "Return to Order",
                "paymentTitle": "Order Payment",
                "manageTitle": "Update Order Info",
                "modelNotFound": "Order not found",
                "failToLoad": "We couldn't load your order details, please try again later.",
                "orderId": "Order management",

                "room_booking_cancelled_successfully": 'Room Booking cancelled successfully',
                "room_booking_cancel_error": 'Room Booking cancelled successfully',
                "cancel_room_booking_warning": 'By cancelling the room you will lost the room booking & price, are you sure?',
                "cancel_booking": 'Cancel Booking',
                "incompleteDPsWereRemoved": 'Incomplete dynamic packages were removed from your cart. Please add them again with both hotel+flight and event tickets.',
            },
            "attractionQuestions": {
                "participant": "Participant",
                "customerInfo": "Customer Info",
                "participantsInfo": "Participants Info",

                "first_name": "First Name",
                "last_name": "Last Name",
                "email_address": "Email Address",
                "phone_number": "Phone Number",
                "pickup_location": "Pickup Location",
                "height_in_centimeters": "Height in Centimeters",
                "weight_in_kilograms": "Weight in Kilograms",
            },
            "completionForm": {
                "paymentFinish": {
                    "title": "The order was made successfully - payment completed",
                    "info": "An email with order details was sent to your address"
                },
                "waitingToApprove": {
                    "title": "Your order has been sent for approval",
                    "info1": "Order details were saved in the system and sent for approval.",
                    "info2": "SubscriptionPayment will only be made after order approval.",
                    "info3": "An email with order confirmation and payment will be sent after order approval."
                },
                "paymentFail": {
                    "title": "SubscriptionPayment failed",
                    "info1": "SubscriptionPayment failed :(",
                    "infoFail": "After several attempts, the charge failed - please try again",
                    "infoWhatsapp": "If an error occurred and you cannot pay, please contact via WhatsApp at: "
                },
                "orderNum": "Order number",
                "thanksForChoose": "Thank you for choosing",
                "free": {
                    "title": "Registration was successful",
                    "info": "An email with a summary of the order was sent to you"
                },
                "pay_later": {
                    "title": "Registration was successful",
                    "info": "An email with order confirmation was sent to you"
                }
            },
            "paymentForm": {
                "card": "Card",
                "creditCardInterest": "Credit Card Interest",
                "interest": "Interest",
                "noInterest": "Interest-free payments",
                "monthlyPayments": "Monthly Payment of",
                "monthsCount": "Months Count",
                "priceCanNotBeOverBalance":"Price can not be over balance",
                "total":"Total link",
                "balance":"Total Balance",
                "updatedBalance":"updatedBalance",
                "copyLink":"Copy link",
                "linkFor":"Link for",
                "back":"Back",
                "setSpecificPrice":"Payment Link",
                "createLink":"Create link",
                "setPriceAndSendPaymentLinkToClient":"Set price and send payment to client",
                "clientName": "Client Name",
                "paymentPageFor": "Payment Page For",
                "forPayment": "For Payment",
                "price": "Price",
                "copyPaymentLink": "Copy Payment Link",
                "pleaseFillInBothFields": "Please fill in both fields.",
                "paymentLinkCopiedToClipboard": "Payment link copied to clipboard!",
                "createLinkForPrice": "Create Link for Payment",
                "creditNotSaveInBd": "Credit card details are not saved on the site - you are making a secure payment",
                "title": "Enter payment method (Visa & Mastercard ONLY)",
                "splitBtn": "Click to split credit cards",
                "splitTitle": "Split credit cards",
                "splitDesc": "Choose the number of credit cards for splitting and click confirm",
                "noSplit": "No split",
                "noPayments": "No payments",
                "payments": "Payments",
                "paymentsNum": "Number of payments",
                "withDebit": "With credit",
                "splitBy": "Credit cards",
                "toPay": "To pay",
                "splitApprove": "Confirm",
                "currencyRate": "Charging is done in shekels - according to the tourism rate",
                "splitCurrentCardNum": "Credit split",
                "splitCurrentCardNumFrom": "Out of",
                "errorMessageToRetry": "Attempt No. {retryNum} - SubscriptionPayment failed from the credit card company. Please enter again card details or another card. Website accepts VISA and MASTERCARD cards only.",
                "installments": "Installments",
                "installmentsLabel": "Number of Installments",
                "installmentFee": "Installment Fee",
                "totalToPay": "Total to Pay",
                "perMonth": "Per month",
                "installmentsDisclosure": "Installments processed by your card issuer. Total includes an installment fee.",
            },
            "hotelTypes": {
                "Hotel": "Hotel",
            },
            "hotelDetails": {
                "updateDates": "Update dates",
                "roomTypesToChooseFrom": "Room types to choose from",

                "metapolicy": "Hotel Policy",
                "metaExtraInfo": "Additional Information",
                "not_included": "Not Included",
                "included": "Included",
                "price": "At the cost of",
                "address": "Address",
                "other": "Address",
                "Location": "Hotel Location",
                "At the boutique hotel": "About the Hotel",
                "Room amenities": "Room Amenities",
                "parking": "Parking",
                "pets": "Pets",
                "shuttle": "Shuttle to Airport (One Way)",
                "internet": "Internet Services",
                "extra_bed": "Extra Bed",
                "add_fee": "Additional Fee",
                "children_meal": "Children's Meal",
                "check_in_check_out": "Check-In and Check-Out",

            },
            "sideFilters": {
                "sortBy": "Sort By",
                "price_asc": "Lowest Price",
                "price_desc": "Highest Price",
                "date_asc": "Earliest Date",
                "date_desc": "Latest Date",
                "hotel_stars_asc": "Lowest Hotel Stars",
                "hotel_stars_desc": "Highest Hotel Stars",
                "distance": "Distance",
                "distance_asc": "Closest Distance",
                "distance_desc": "Farthest Distance",
                "recommended": "Recommended",
                "price": "Price",
                "clearSideFilters": "Clear Filters",
                "ts_type": "Flight Types",
                "auto_approve": "Instant Approval",
                "include_transfer": "Include Transfer",
                "include_baggage": "Include Baggage",
                "include_trolly": "Include Trolly",
                "auto_approve_checked": "Showing Instant Approval Results",
                "from_date_hours": "Outbound Flight Time",
                "isSpecial": "Is Special",
                "is_special": "Is Special",
                "date_range": "Date Range",
                "from_date_landing_hours": "Outbound Flight Landing Time",
                "flight_stop_time": "Wait Time",
                "return_date_landing_hours": "Return Flight Landing Time",
                "return_date_hours": "Return Flight Time",
                "airline": "Airline",
                "2": "Charter Flights",
                "3": "Scheduled Flights",
                "nonStop": "Direct Flight",
                "stop": "One Stop",
                "stops_plural": "Stops",
                "hotel_type": "Accommodation Types",
                "stops": "Number of Stops",
                "freeCancellation": "Free Cancellation",
                "freeCancellationLabels": {
                    "1": "Only Free Cancellation",
                    "0": "Without Free Cancellation"
                },

                "feature": "Feature",

                "event_type": "Event Types",
                "avenue": "Avenue",
                "event_date": "Event Date",
                "participants": "Participants",
            },
            "package_feature": {
                "SPECIAL PACKAGE": "Special Package",
                "ALL PACKAGES": "All Packages",
                "KOSHER": "Kosher",
                "TOUR": "Organized Tour",
                "SKI": "Ski",
                "EVENT": "Event",
                "SPORT": "Sport",
                "SPA": "Spa",
                "YOUNG VACATION": "Young Vacation",
                "FLT+HTL+CAR": "FLT+HTL+CAR",
            },
            "hotelAmenities": {
                // "dummy": "dummy"
            },
            "general": {
                "km": "KM",
                "kmFromVenue": "KM from Venue",
                "kmFromCityCenter": "KM from City Center",
                "kmFromCity": "KM from {{city}}",
                "distanceUnavailable": "Distance unavailable",
                openBO: "Open Backoffice",
                logOut: "Log out",
                "clickTo": "Click to",
                "toOrder": "To Order",
                "amount": "Amount",
                parentOriginal: "Parent Original",
                parentEdited: "Parent Edited",
                "fetchingMoreResults": "Fetching more results...",
                "error": "Error",
                "somethingWentWrong": "Something went wrong. Please try again.",
                "noResultsFound": "No events found",
                "tryAdjustingFilters": "Try adjusting your filters or search criteria",
                "refresh": "Refresh",
                "list": "List",
                "matched": "Matched",
                "sameRates": "Same Rates",
                "rates": "Rates",
                "calculatedRates": "Calculated Rates",
                "to": "to",
                "roomOnly": "Room Only",
                "close": "Close",
                "language": "Language",
                "remark": "Remark",
                "orgInfo": "Tour Days",
                "tourInfo": "Tour Info",
                "selectDestination": "Please Select a Destination to Search",
                "addService": "Add Service",
                packagesMainTitle: "Vacation Packages",
                additionalPackages: "Additional packages",
                additionalFlights: "Additional flights",
                packagePlan: "Vacation packages from",
                immediateApproval: "immediate approval",
                vacationAtHeader: "Vacation at",
                daysOfStay: "Days of stay",
                lowPrice: "Low Price",
                flightUpTo: "Flight from",
                flightsPromoTitle: "last flights",
                "attraction":"Attraction",
                "includeReturnSuitcase":"Suitcase included for flight back",
                "total": "Total",
                "as_of_today": "as of today",
                "priceInIls": "({price} ₪)",
                "link_to_the_offer": "Link to the offer",
                "the_quote_has_been_copied_successfully": "The quote has been copied successfully",
                "base": "Basis",
                "sort": "Sort",
                "submit": "Submit",
                "maxAmountOf": "Max Amount Of",
                "minAmountOf": "Min Amount Of",
                "ticketType": "Ticket Type",
                "cancellation_policy": "Cancellation Policy",
                "additionalInfo": "Additional Information",
                "hour": "Hour",
                "minute": "Minute",
                "before": "Before",
                "date": "Date",
                "duration": "Duration",
                "quantity": "Quantity",
                "tickets": "Tickets",
                "deliveryMethod": "Delivery Method",
                "for": "for",
                "free": "free",
                "freeOfCharge": "Free of Charge",
                'option': 'Option',
                'removeSelection': 'Unselect',
                'grandTotalPrice': 'Grand Total Price',
                'totalPrice': 'Total Price',
                'startingPrice': 'Starting price',
                "usd": "USD",
                "euro": "EURO",
                "address": "Address",
                "type": "Type",
                "noResults": "No results",
                "boardBasis": "Board Basis",
                "nights": "Nights",
                "supplier": "Supplier",
                "airLine": "AirLine",
                "price": "Price",
                "totalRoomPrice": "Total Price",
                "priceForXRooms": "Price for X rooms",
                "hotel": "Hotel",
                "hotel_stars": "Hotel Stars",
                "minPrice": "Min Price",
                "BB": "BB",
                "HB": "HB",
                "cancel": "Cancel",
                "replaceShoppingCart": "Replace Shopping Cart",
                "replace": "Replace",
                "searchForUser": "Search For User",
                "acceptCookiesTitle":"This website uses cookies to ensure you get the best experience on our website.",
                "acceptCookiesBtn":"Accept",
                "includesActivities": "{NUMBER} gift attractions!",
                "includesActivity": "Includes a gift attraction!",
                "adults": "Adults",
                "all_include": "All inclusive",
                "breakfast": "Breakfast",
                "half_board": "Half board",
                "half_board_kosher": "Kosher half board",
                "full_board": "Full board",
                "sleep_only": "Accommodation only",
                "breakfast_kidush": "Friday breakfast and dinner",
                "addToCard": "Add to order",
                "chooseRoom": "Choose composition and room",
                "boardType": "Accommodation basis",
                "filters": "Filters",
                "rating": "Hotel rating",
                "event": "Event",
                "attraction_stars": "Attraction rating",
                "selected": "Selected",
                "name": "Name",
                "taxonomies": "Taxonomies",
                "children": "Children",
                "toDate": "Until",
                "transfers": "Transfers",
                "from": "Starting from",
                "perPerson": "Per person",
                "perPax": "Per Pax",
                "include": "Includes",
                "noIncludeText": "Vacation packages",
                "flights": "Flights",
                "vacationAt": "Vacation in {DEST}",
                "fieldRequired": "Mandatory field",
                "showAll":"Show All",
                "showLess":"Show Less",
                "flight" : "Flight",
                "h": "h",
                "min": "min",

                "availableSeats": "Available Seats",
                "showGrossPrice": "Gross Price ON",
                "showNetPrice": "Net Price ON",
                "noRating": "No Rating",
                "bundleFlight": "Round Trip Flight",
                "oneWayBundleFlight": "One-Way Flight",
                "trollyIsIncluded": "Trolley Included",
                "trollyIsNotIncluded": "No Trolley",
                "suitcaseIsIncluded": "Suitcase Included",
                "suitcaseIsNotIncluded": "Suitcase Not Included",
                "additionalSuitcases": "Includes X Suitcases",
                "additionalTrolly": "Includes X Trolleys",
                "returnFlight": "Return Flight",
                "outboundFlight": "Outbound Flight",
                "agentMode": "Agent Mode",
                "userMode": "Client Mode",
                "suitcase": "Suitcase",
                "trolly": "Trolley",
                "packageSearchResult": "The packages we found for you",
                "day": "Day",
                "selectDate": "Select Dates",
                "search": "Search",
                "adult": "Adult",
                "child": "Child",
                "infant": "Infant",
                "infants": "Infants",

                "loading": "Loading",
                "showingMoreResults": "Showing More Results",
                "noMoreResults": "No More Results",
                "NoResultsMatchedTheFilterValues": "No Results Matched the Filter Values",
                "noHotelsFound": "No hotels were found for the selected search",
                "noFlightsFound": "No flights were found for the selected search",
                "noEventsFound": "No events were found for the selected search",
                "noPackagesFound": "No packages were found for the selected search",
                "eventTicketsAdded": "Event Tickets Added",
                "addEventTickets": "Add Event Tickets",
                "add": "Add",
            },
            "subsidizedForm": {
                "title": "Add subsidy",
                "employee_id": "Employee number",
                "person_id": "ID number (9 digits)",
                "validate": "Check employee code",
                "alreadyApplied": "Subsidy already applied",
                "addOneMore": "Add another subsidy",
                "addOneMoreId": "Add another employee",
                "fieldRequired": "Mandatory field",
                "priceReducedBy": "Price reduced by",
                "forEmployee": "For employee",
                "employeeIs": "Successfully identified",
                "error4401": "Failed to identify, try again",
                "error4402": "Code identified, but already in use",
                "guestIdentifiedId": "Identified by ID",
                "guestNotIdentified": "You must identify before registering",
                "clickToIdentify": "Click to identify"
            },
            "uploadImage": {
                "uploadPassportImage": "Upload passport photo",
                "somethingWentWrong": "Something went wrong"
            },
            "flightButton":{
                "no_availability_for_this_flight_price": "Sorry but there is no more availability for this flight pricing",
                "cardConditions": "Ticket Terms",
                "flightTotalPrice": "One-Way Flight Price",
                "total": "Total",
                "continueToOrder": "Move to Order",
                "addToCart": "Add to Cart",
                "lastPlace": "Last Seats Available",
                "pricePerPassenger": "Price per Passenger",
            },
            "workflows":{
                "regular": "Regular",
                "FULL": "Full",
                "BOOKING_FREE_CANCELLATION": "Booking Free Cancellation",
                "PAYMENT_COMPLETED_FOR_FREE_CANCELATION": "Payment Completed for Free Cancellation",
                "BOOKING_ONLY": "Booking Only",
            },
            "agentCommission":{
                "supplier": "Supplier",
                "commission": "Commission",
                "netPrice": "Net Price",
                "recommendedFee": "Recommended Fee",
                "transactionDetailsForAgent": "Agent Details",
                "supplierNotes": "Supplier Notes",
                "cancellationConditions": "Cancellation Conditions",
                "addToCartToChangeFree": "Add to Cart to Change Commission",
                "pricesShownAreNetPrices": "Net prices are shown",
                "pricesShownAreGrossPrices": "Gross prices are shown",
                "packageRemarks": "package remarks",
            },
            "support": {
                "contactSupport": "Contact Support",
                "submitTicket": "Submit a Ticket",
                "myTickets": "My Tickets",
                "viewMyTickets": "View My Tickets",
                "selectCategory": "Select Category",
                "selectReason": "Select Reason",
                "linkOrder": "Link Order (Optional)",
                "describeIssue": "Describe Your Issue",
                "review": "Review & Submit",
                "categoryFlights": "Flights",
                "categoryHotels": "Hotels",
                "categoryPackages": "Packages",
                "categoryBilling": "Billing & Payments",
                "categoryTechnical": "Technical Support",
                "categoryOther": "Other",
                "reasonBookingIssue": "Booking Issue",
                "reasonFlightCancellation": "Flight Cancellation",
                "reasonFlightChange": "Flight Change Request",
                "reasonSeatSelection": "Seat Selection",
                "reasonBaggageIssue": "Baggage Issue",
                "reasonRefundRequest": "Refund Request",
                "reasonOther": "Other",
                "reasonReservationChange": "Reservation Change",
                "reasonRoomUpgrade": "Room Upgrade",
                "reasonCancellationRequest": "Cancellation Request",
                "reasonAmenitiesQuestion": "Amenities Question",
                "reasonAddServices": "Add Services",
                "reasonPackageModification": "Package Modification",
                "reasonItineraryQuestion": "Itinerary Question",
                "reasonPaymentFailed": "Payment Failed",
                "reasonRefundStatus": "Refund Status",
                "reasonInvoiceRequest": "Invoice Request",
                "reasonPricingQuestion": "Pricing Question",
                "reasonPaymentMethod": "Payment Method",
                "reasonLoginProblem": "Login Problem",
                "reasonWebsiteError": "Website Error",
                "reasonMobileAppIssue": "Mobile App Issue",
                "reasonPaymentGateway": "Payment Gateway",
                "reasonGeneralInquiry": "General Inquiry",
                "reasonFeedback": "Feedback",
                "reasonComplaint": "Complaint",
                "reasonSuggestion": "Suggestion",
                "fullName": "Full Name",
                "fullNamePlaceholder": "Enter your full name",
                "email": "Email",
                "emailPlaceholder": "your.email@example.com",
                "phone": "Phone (Optional)",
                "phonePlaceholder": "+ 972 -",
                "subject": "Subject",
                "subjectPlaceholder": "Brief description of your issue",
                "priority": "Priority",
                "priorityLow": "Low",
                "priorityMedium": "Medium",
                "priorityHigh": "High",
                "priorityUrgent": "Urgent",
                "description": "Detailed Description",
                "descriptionPlaceholder": "Please provide as much detail as possible about your issue...",
                "attachments": "Attachments",
                "attachmentsHint": "You can attach up to 5 files (max 2MB each)",
                "selectOrder": "Select Related Order",
                "searchOrders": "Search orders by destination, dates, or order ID...",
                "noOrders": "No orders found",
                "manualOrderId": "Enter your order ID:",
                "orderIdPlaceholder": "e.g., 12345",
                "signedInAs": "Signed in as",
                "guestUser": "Guest User",
                "requiredForGuests": "Required for submission",
                "consentLabel": "I agree to the terms and conditions",
                "consentText": "By submitting this ticket, I confirm that the information provided is accurate and I consent to Sky 360 processing my personal data to resolve my inquiry.",
                "next": "Next",
                "back": "Back",
                "submit": "Submit Ticket",
                "cancel": "Cancel",
                "addFile": "Add File",
                "removeFile": "Remove",
                "selectFile": "Select Files",
                "required": "This field is required",
                "invalidEmail": "Please enter a valid email address",
                "selectCategoryRequired": "Please select a category",
                "selectReasonRequired": "Please select a reason",
                "descriptionTooShort": "Please provide more details (minimum 20 characters)",
                "fileTooLarge": "File size exceeds 2MB limit",
                "tooManyFiles": "Maximum 5 files allowed",
                "invalidFileType": "This file type is not supported",
                "consentRequired": "You must agree to the terms to submit",
                "successTitle": "Ticket Submitted Successfully!",
                "successMessage": "Your support ticket has been created. We will review it shortly and get back to you.",
                "ticketNumber": "Ticket Number",
                "nextSteps": "What happens next?",
                "nextStepsText": "Our support team will review your ticket and respond within 24-48 hours. You will receive email updates at",
                "emailConfirmation": "A confirmation email has been sent to your inbox.",
                "ticketId": "Ticket",
                "status": "Status",
                "category": "Category",
                "lastUpdated": "Last Updated",
                "created": "Created",
                "open": "Open",
                "pending": "Pending",
                "resolved": "Resolved",
                "closed": "Closed",
                "noTickets": "No support tickets found",
                "noTicketsMessage": "You haven't submitted any support tickets yet.",
                "orderNumber": "Order",
                "orderDestination": "Destination",
                "orderDates": "Travel Dates",
                "orderAmount": "Amount",
                "orderStatus": "Status",
                "priorityP1": "Critical",
                "priorityP2": "High",
                "priorityP3": "Medium",
                "priorityP4": "Low",
                "errorSubmitting": "Failed to submit ticket. Please try again.",
                "errorLoadingOrders": "Failed to load orders.",
                "networkError": "Network error. Please check your connection.",
                "needHelp": "Need Help?",
            },
            "blog": {
                "home": "Home",
                "blog": "Blog",
                "categories": "Categories",
                "articles": "Articles",
                "articlesIn": "articles in",
                "latestTravelStories": "Latest Travel Stories",
                "discoverInspiring": "Discover inspiring destinations and expert travel tips",
                "viewAllArticles": "View All Articles",
                "showAllPostsForCategory": "Show all posts for {category}",
                "readMore": "Read More",
                "minRead": "min read",
                "addBookmark": "Add Bookmark",
                "removeBookmark": "Remove Bookmark",
                "shareThisArticle": "Share This Article",
                "shareThisCategory": "Share This Category",
                "shareWithFriendsAndFamily": "Share your favorite destination articles with friends and family",
                "share": "Share",
                "shareOnFacebook": "Share on Facebook",
                "shareOnTwitter": "Share on Twitter",
                "shareOnLinkedIn": "Share on LinkedIn",
                "shareOnPinterest": "Share on Pinterest",
                "shareOnInstagram": "Share on Instagram",
                "copyLink": "Copy Link",
                "linkCopied": "Link copied to clipboard!",
                "copied": "Copied!",
                "copyFailed": "Failed to copy link",
                "followUs": "Follow Us",
                "instagram": "Instagram",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "relatedArticles": "Related Articles",
                "noRelatedArticles": "There are no other articles in this category yet.",
                "seeMore": "See more",
                "seeLess": "See less",
                "experienceItYourself": "Experience it Yourself",
                "exploreOffer": "View Details",
                "nights": "nights",
                "travelers": "travelers",
                "productTypes": {
                    "package": "Package",
                    "hotel": "Hotel",
                    "flight": "Flight",
                    "attraction": "Attraction"
                },
                "noPostsFound": "No posts found in this category",
                "noPostsAvailable": "No articles available at the moment.",
                "postNotFound": "Post not found",
                "showing": "Showing",
                "sortBy": "Sort by:",
                "newestFirst": "Newest First",
                "alphabetical": "A-Z",
                "gridView": "Grid View",
                "listView": "List View",
                "exploreMoreCategories": "Explore More Categories",
                "travelInspiration": "Travel Inspiration",
                "getWeeklyGuides": "Discover hidden gems and exclusive travel tips curated for adventurers like you",
                "bookYourFlight": "Book Your Flight",
                "facebookShare": "Facebook",
                "twitterShare": "Twitter",
                "instagramShare": "Instagram",
                "linkedinShare": "LinkedIn",
                "whatsappShare": "WhatsApp",
                "pinterestShare": "Pinterest",
                "shareArticle": "Share Article",
                "shareCategory": "Share Category",
            },
        "bot": {
            "title": "Sky360 Travel Assistant",
            "newChat": "New Chat",
            "previewCart": "Preview cart",
            "addingToCart": "Adding to cart…",
            "collapsed": {
                "youChose": "Your pick:",
                "yourPick": "Your pick",
                "title": {
                    "flight": "Flight options",
                    "hotel": "Hotel options",
                    "package": "Package options",
                    "activity": "Activity options",
                    "event": "Event options",
                    "room": "Room options"
                }
            },
            "blocked": "This chat has been disabled.",
            "reconnecting": "Reconnecting…",
            "connectionError": "Connection error — retrying…",
            "emptyState": {
                "title": "How can I help plan your trip?",
                "subtitle": "Ask me about flights, hotels, packages, or activities.",
                "subtitlePrefix": "Ask me about ",
                "productNoun": {
                    "flight": "flights",
                    "hotel": "hotels",
                    "package": "packages",
                    "activity": "activities",
                    "event": "events"
                },
                "starters": [
                    { "label": "Plan a beach getaway", "value": "I want to plan a beach getaway" },
                    { "label": "Find a city break", "value": "I want a city break for a long weekend" },
                    { "label": "Book a flight", "value": "I just need flights" }
                ]
            },
            "input": {
                "placeholder": "Ask me anything about your trip…",
                "disabled": "Chat disabled"
            },
            "sessionLimit": {
                "title": "You've started too many chats",
                "body": "To keep the service available, please wait a moment before starting a new one.",
                "countdown": "You can start a new chat in {{time}}",
                "existingChats": "Your existing chats still work as usual.",
                "ready": "You can start a new chat now.",
                "inputPlaceholder": "Please wait {{time}}…",
                "genericTitle": "Couldn't start the chat",
                "genericBody": "Something went wrong on our side. Please try sending again."
            },
            "itinerary": {
                "titleOne": "1 item · {{total}}",
                "titleOther": "{{count}} items · {{total}}",
                "total": "Total",
                "remove": "Remove"
            },
            "checkout": {
                "title": "Your Itinerary",
                "travellers": "Travellers",
                "total": "Total",
                "confirmBook": "Confirm & Book",
                "completeBooking": "Complete booking",
                "openInNewTab": "Open checkout in a new tab:",
                "failed": "We could not open checkout. Please try again.",
                "emptyCart": "Your cart is empty — add something before checking out."
            },
            "result": {
                "select": "Select",
                "direct": "Direct",
                "stopsOne": "1 stop",
                "stopsOther": "{{count}} stops",
                "freeCancellation": "Free cancellation",
                "return": "Return",
                "nights": "nights",
                "perNight": "/night",
                "outbound": "Outbound",
                "transferIncluded": "Transfer included",
                "flightsIncluded": "Flights included",
                "suitcaseIncluded": "Suitcase included",
                "noSuitcase": "No suitcase",
                "trolleyIncluded": "Trolley included",
                "noTrolley": "No trolley",
                "flightOptionsOne": "1 flight option",
                "flightOptionsOther": "{{count}} flight options",
                "moreFlightOptionsOne": "+1 more flight option for this hotel",
                "moreFlightOptionsOther": "+{{count}} more flight options for this hotel"
            },
            "room": {
                "sleeps": "Sleeps {{count}}"
            }
        },
        "changeApproval": {
            "greeting": "Hello",
            "subtitle": "Your flight has been updated",
            "changeTableTitle": "Change Details",
            "colField": "Field",
            "colBefore": "Before",
            "colAfter": "After",
            "confirmPrompt": "Please confirm you are aware of this change to your booking.",
            "confirmBtn": "Confirm change",
            "declineBtn": "I decline",
            "expiresLabel": "Expires",
            "expiresIn": "Link expires in",
            "confirmedTitle": "Change Confirmed",
            "confirmedMsg": "You confirmed this change on",
            "declinedTitle": "Change Declined",
            "declinedMsg": "You declined this change. Our team will contact you.",
            "expiredTitle": "Link Expired",
            "expiredMsg": "This link has expired. Please contact support.",
            "failedTitle": "Link Not Available",
            "failedMsg": "This link is not available. Please contact support.",
            "errorBanner": "An error occurred. Please try again.",
            "loading": "Loading...",
            "orderLabel": "Order",
            "days": "days",
            "hours": "hours",
            "minutes": "minutes"
        }
      }
    }
};

export default translationsEn;